// # # # # # # # # # # # # # # # # # # # #
// # Automatically generated file!       #
// # Update via: pnpm run apollo:update  #
// # # # # # # # # # # # # # # # # # # # #

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Bic: { input: any; output: any; }
  Cid: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Iban: { input: any; output: any; }
  Iid: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  LongEntityId: { input: any; output: any; }
  NaiveDate: { input: any; output: any; }
  NaiveTime: { input: any; output: any; }
  ObjectId: { input: any; output: any; }
  Oid: { input: any; output: any; }
  RoleId: { input: any; output: any; }
  StrictEntityId: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Uid: { input: any; output: any; }
  YearMonth: { input: any; output: any; }
};

export type AccessInput = {
  customer?: InputMaybe<CustomerLevel>;
  customerUnit?: InputMaybe<CustomerUnitLevel>;
  institution?: InputMaybe<InstitutionLevel>;
  organization?: InputMaybe<OrganizationLevel>;
  organizationUnit?: InputMaybe<OrganizationUnitLevel>;
};

export enum AccessLevel {
  Customer = 'CUSTOMER',
  Institution = 'INSTITUTION',
  Organization = 'ORGANIZATION',
  OrganizationUnit = 'ORGANIZATION_UNIT'
}

export type AccordingToCalendar = {
  __typename?: 'AccordingToCalendar';
  /** This field is needed, because GraphQL cannot handle structs without fields in Unions or OneofObjects */
  ignoreThis: Scalars['Int']['output'];
};

export type AccordingToCalendarInput = {
  /** This field is needed, because GraphQL cannot handle structs without fields in Unions or OneofObjects */
  ignoreThis?: Scalars['Int']['input'];
};

export type AccordingToOpeningDays = {
  __typename?: 'AccordingToOpeningDays';
  /** This field is needed, because GraphQL cannot handle structs without fields in Unions or OneofObjects */
  ignoreThis: Scalars['Int']['output'];
};

export type AccordingToOpeningDaysInput = {
  /** This field is needed, because GraphQL cannot handle structs without fields in Unions or OneofObjects */
  ignoreThis?: Scalars['Int']['input'];
};

export enum AccountedStatus {
  Accounted = 'ACCOUNTED',
  Open = 'OPEN'
}

export type AccountingGroup = {
  __typename?: 'AccountingGroup';
  /**
   * "Abrechnen zum"
   * -1 represents "monatsletzten".
   * 0 represents "null".
   * 1 up to 31 represents the date of the month.
   */
  accountAtDayOfMonth: Scalars['Int']['output'];
  /** "Beitragsschema-ID" */
  accountingGroupId?: Maybe<Scalars['String']['output']>;
  /** "Bereich" */
  category?: Maybe<GeneralFeeCategory>;
  created: Modification;
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  modified?: Maybe<Modification>;
  /** "monatliche Erhebung: Anzahl Monate" */
  months?: Maybe<Months>;
  n: Scalars['Int']['output'];
  /** "Bezeichnung" */
  name: Scalars['String']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  /** "Beitragserhebung" */
  repetition?: Maybe<Repetition>;
  standard: Scalars['Boolean']['output'];
};

export type AccountingGroupList = {
  __typename?: 'AccountingGroupList';
  items: Array<AccountingGroup>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type AccountingRun = {
  __typename?: 'AccountingRun';
  accountingDate: Scalars['NaiveDate']['output'];
  accountingGroup: AccountingGroup;
  accountingGroupId: Scalars['ObjectId']['output'];
  created: Modification;
  /** Get the  [`Fees`](Fee), that this accounting run accounted. */
  fees: Array<Fee>;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  receiptDate: Scalars['NaiveDate']['output'];
  receiptDueDate: Scalars['NaiveDate']['output'];
  /** Get the receipts created by the accounting run */
  receipts: Array<Receipt>;
  receiptsNumber: Scalars['Int']['output'];
  receiptsTotalAmount: Scalars['Float']['output'];
  yearMonth: Scalars['YearMonth']['output'];
};

export type AccountingRunList = {
  __typename?: 'AccountingRunList';
  items: Array<AccountingRun>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

/** An owned version of an RcObject, used to send to the frontend to add data such as `id`, `organization`, `institution` and `linked_to`. */
export type Address = {
  __typename?: 'Address';
  accountHolder?: Maybe<Scalars['String']['output']>;
  bankInstitution?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['Bic']['output']>;
  birthdate?: Maybe<Scalars['NaiveDate']['output']>;
  /** Get the associated [`Categories`](Category). */
  categories?: Maybe<Array<AddressCategory>>;
  city?: Maybe<Scalars['String']['output']>;
  collectiveInvoice: Scalars['Boolean']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  country?: Maybe<Scalars['String']['output']>;
  debtorNumber: Scalars['Int']['output'];
  district?: Maybe<Scalars['String']['output']>;
  doctor?: Maybe<Scalars['Boolean']['output']>;
  employer?: Maybe<Scalars['Boolean']['output']>;
  externalAddress?: Maybe<Scalars['Boolean']['output']>;
  externalPayer?: Maybe<Scalars['Boolean']['output']>;
  facility?: Maybe<Scalars['String']['output']>;
  financialAccountingData: FinancialAccountingData;
  firstname?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['Iban']['output']>;
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  lastname?: Maybe<Scalars['String']['output']>;
  /** Get [Institutions](Institution) this object is linked to. */
  linkedTo: Array<Institution>;
  n: Scalars['Int']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  otherAddress?: Maybe<Scalars['Boolean']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  specialService?: Maybe<Scalars['Boolean']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  volunteer?: Maybe<Scalars['Boolean']['output']>;
  volunteerDescription?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressCategory = {
  __typename?: 'AddressCategory';
  addressId: Scalars['ObjectId']['output'];
  /**
   * Get the [`Category`] object.
   *
   * Requires rights to the `category` resource.
   */
  category?: Maybe<Category>;
  categoryId: Scalars['ObjectId']['output'];
  created: Modification;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type AddressList = {
  __typename?: 'AddressList';
  items: Array<Address>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export enum Allocation {
  NotSubsidizable = 'NOT_SUBSIDIZABLE',
  NoAllocation = 'NO_ALLOCATION',
  Subsidizable = 'SUBSIDIZABLE'
}

export type Alternative1 = {
  __typename?: 'Alternative1';
  percent: Scalars['Int']['output'];
};

export type Alternative1Input = {
  percent: Scalars['Int']['input'];
};

export type Alternative2 = {
  __typename?: 'Alternative2';
  percent: Scalars['Int']['output'];
};

export type Alternative2Input = {
  percent: Scalars['Int']['input'];
};

/**
 * A model for the two time columns in the booking time table.
 *
 * The `am` time range must come before the `pm` time range, if both are specified.
 * TimeRange is expected to have both `start` and `end` set.
 */
export type AmPm = {
  __typename?: 'AmPm';
  am?: Maybe<TimeRange>;
  pm?: Maybe<TimeRange>;
};

/**
 * A model for the two time columns in the booking time table.
 *
 * The `am` time range must come before the `pm` time range, if both are specified.
 * TimeRange is expected to have both `start` and `end` set.
 */
export type AmPmInput = {
  am?: InputMaybe<TimeRangeInput>;
  pm?: InputMaybe<TimeRangeInput>;
};

export type Analysis = {
  __typename?: 'Analysis';
  children: Array<AnalysisChild>;
  childrenCount: Scalars['Int']['output'];
  created: Modification;
  createdFromCurrentData: Scalars['Boolean']['output'];
  employees: Array<AnalysisEmployee>;
  fundingAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  options: AnalysisOptions;
  remark?: Maybe<Scalars['String']['output']>;
  staffingRatio?: Maybe<Scalars['Float']['output']>;
  year: Year;
};

export type AnalysisChild = {
  __typename?: 'AnalysisChild';
  birthdate: Scalars['NaiveDate']['output'];
  bookings: MonthlyBookings;
  commune?: Maybe<Commune>;
  communeId?: Maybe<Scalars['StrictEntityId']['output']>;
  institutionSection?: Maybe<InstitutionSection>;
  institutionSectionId?: Maybe<Scalars['StrictEntityId']['output']>;
  kibigId: Scalars['String']['output'];
  kibigName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preCourse: PreCourse;
  shortTimeBookingTime: BookingTime;
  shortTimeCommuneKey: Scalars['String']['output'];
  shortTimeDays: Scalars['Int']['output'];
  shortTimeSubsidyState: ChildSubsidyState;
  vacationBookingTime: BookingTime;
  vacationCommuneKey: Scalars['String']['output'];
  vacationDays: Scalars['Int']['output'];
  vacationSusidyState: ChildSubsidyState;
};

export type AnalysisChildInput = {
  birthdate: Scalars['NaiveDate']['input'];
  bookings: MonthlyBookingsInput;
  communeId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  institutionSectionId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  kibigId: Scalars['String']['input'];
  kibigName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  preCourse: PreCourse;
  shortTimeBookingTime: BookingTime;
  shortTimeCommuneKey: Scalars['String']['input'];
  shortTimeDays: Scalars['Int']['input'];
  shortTimeSubsidyState: ChildSubsidyState;
  vacationBookingTime: BookingTime;
  vacationCommuneKey: Scalars['String']['input'];
  vacationDays: Scalars['Int']['input'];
  vacationSusidyState: ChildSubsidyState;
};

export type AnalysisEmployee = {
  __typename?: 'AnalysisEmployee';
  employmentMonths: MonthlyRecords;
  kibigId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AnalysisEmployeeInput = {
  employmentMonths: MonthlyRecordsInput;
  kibigId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AnalysisList = {
  __typename?: 'AnalysisList';
  items: Array<Analysis>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type AnalysisOptions = {
  __typename?: 'AnalysisOptions';
  districtSubsidy?: Maybe<Region>;
  factorIncrease?: Maybe<FactorIncrease>;
  rural?: Maybe<RuralKita>;
};

export type Appointment = {
  __typename?: 'Appointment';
  absence: Scalars['Boolean']['output'];
  /** Get the associated [`Child`](Child). */
  children?: Maybe<Array<AppointmentChild>>;
  /** Get the associated [`Employee`](Employee). */
  employees?: Maybe<Array<AppointmentEmployee>>;
  from: Scalars['DateTime']['output'];
  fullDay: Scalars['Boolean']['output'];
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  n: Scalars['Int']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  subject: Scalars['String']['output'];
  subtype?: Maybe<AppointmentType>;
  text?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
  type: AppointmentType;
};

export type AppointmentChild = {
  __typename?: 'AppointmentChild';
  /**
   * Get the associated [`Appointment`] object.
   *
   * Requires rights to the `appointment` resource.
   */
  appointment?: Maybe<Appointment>;
  appointmentId: Scalars['ObjectId']['output'];
  /**
   * Get the associated [`Child`] object.
   *
   * Requires rights to the `child` resource.
   */
  child?: Maybe<Child>;
  childId: Scalars['ObjectId']['output'];
  created: Modification;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type AppointmentEmployee = {
  __typename?: 'AppointmentEmployee';
  /**
   * Get the associated [`Appointment`] object.
   *
   * Requires rights to the `appointment` resource.
   */
  appointment?: Maybe<Appointment>;
  appointmentId: Scalars['ObjectId']['output'];
  created: Modification;
  /**
   * Get the associated [`Employee`] object.
   *
   * Requires rights to the `employee` resource.
   */
  employee?: Maybe<Employee>;
  employeeId: Scalars['ObjectId']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type AppointmentList = {
  __typename?: 'AppointmentList';
  items: Array<Appointment>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type AppointmentQueryFilter = {
  childId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  employeeId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  subtype?: InputMaybe<Array<AppointmentType>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Array<AppointmentType>>;
};

export enum AppointmentType {
  /** Seminar day (Seminartag) */
  A = 'A',
  /** Employment ban (Beschäftigungsverbot) */
  B = 'B',
  /** Expert converence (Fachtagung) */
  C = 'C',
  /** Child Sick (Erkrankung Kind) */
  E = 'E',
  /** Advanced training (Fortbildung) */
  F = 'F',
  /** Abscence (Freistellung) */
  G = 'G',
  /** Sick (Krank) */
  K = 'K',
  /** Flex day (Gleittag) */
  L = 'L',
  /** Maternity leave (Mutterschutz) */
  M = 'M',
  /** Regeneration day (Regenerationstag) */
  R = 'R',
  /** Misc (Sonstiger Termin) */
  S = 'S',
  /** Leave (Urlaub) */
  U = 'U',
  /** Change day (Umwandlungstag) */
  W = 'W',
  /** Closing time for advanced team training (Schließzeit Teamfortbildung) */
  Y = 'Y',
  /** Closing time (Schließzeit) */
  Z = 'Z'
}

export enum Area {
  /** "9 Gruppenübergreifend tätig" */
  ActiveAcrossGroups = 'ACTIVE_ACROSS_GROUPS',
  /** "5 Verwaltung" */
  Administration = 'ADMINISTRATION',
  /** "3 Förderung von Kindern nach SGB VIII/SGB XII" */
  Furtherance = 'FURTHERANCE',
  /** "1 Gruppenleitung" */
  GroupManager = 'GROUP_MANAGER',
  /** "4 Einrichtungsleitung" */
  InstitutionOwner = 'INSTITUTION_OWNER',
  /** "2 Zweit- bzw. Ergänzungskraft" */
  SupportingStaff = 'SUPPORTING_STAFF'
}

export type Bank = {
  __typename?: 'Bank';
  accountHolder?: Maybe<Scalars['String']['output']>;
  bankInstitution?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['Bic']['output']>;
  iban?: Maybe<Scalars['Iban']['output']>;
};

export type Birth = {
  __typename?: 'Birth';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['NaiveDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  saintsDay?: Maybe<Scalars['NaiveDate']['output']>;
};

export type BirthInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['NaiveDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saintsDay?: InputMaybe<Scalars['NaiveDate']['input']>;
};

export type Booking = {
  __typename?: 'Booking';
  /** "Eingliederungshilfe" */
  assistedIntegration: Scalars['Boolean']['output'];
  /** Get the associated [`BookingDay`]s */
  bookingDays: Array<BookingDay>;
  /**
   * Get the associated [`Commune`](Commune).
   *
   * Requires rights to the `commune` resource.
   */
  commune?: Maybe<Commune>;
  /**
   * Get the associated [`Contract`].
   *
   * Requires rights to the `contract` resource.
   */
  contract: Contract;
  contractId: Scalars['StrictEntityId']['output'];
  /** "Bezirksförderung" */
  districtSubsidy: Scalars['Boolean']['output'];
  /** "Ausnahme für Elternbeitragszuschuss" */
  exceptionForParentalFeeSubsidy: Scalars['Boolean']['output'];
  /** "Ausnahme für Förderung" */
  exceptionForSubsidy: Scalars['Boolean']['output'];
  from: Scalars['NaiveDate']['output'];
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  isPreSchooler: Scalars['Boolean']['output'];
  isSchoolChild: Scalars['Boolean']['output'];
  /** "Mittagsverpflegung durch die Einrichtung" */
  lunch: Scalars['Boolean']['output'];
  /** "Migration" */
  migration: Scalars['Boolean']['output'];
  n: Scalars['Int']['output'];
  /** "Krippenkind" */
  nurseryChild: Scalars['Boolean']['output'];
  /** "Krippenkind" exception § 21 (5) 5f BayKiBiG */
  nurseryChildException: Scalars['Boolean']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  /** "Vorkurs" */
  preCourse: Scalars['Boolean']['output'];
  /** "Vorschulkind" with corresponding status */
  preSchooler?: Maybe<Enrollment>;
  /** "Anmerkungen zur Buchung" */
  remarks?: Maybe<Scalars['String']['output']>;
  schoolData?: Maybe<SchoolData>;
  /**
   * Get the associated [section](`InstitutionSection`).
   *
   * Requires rights to the `institution` resource.
   */
  section?: Maybe<InstitutionSection>;
  /**
   * Set the time factor always
   *
   * If the `time_factor_manually_set` is `false` and the [`TimeFactorData`] does not match the actual `times: BookingTimes`, the `times` field should be used as the source of truth for further calculation.
   */
  timeFactor: TimeFactorData;
  /** Flag if the user set the time factor themselves */
  timeFactorManuallySet: Scalars['Boolean']['output'];
  times: BookingTimes;
  to?: Maybe<Scalars['NaiveDate']['output']>;
  /** This will reflect the variant of the `BookingType` object */
  type: BookingTypeEnum;
  typeObject: BookingTypeObject;
};

export type BookingDay = {
  __typename?: 'BookingDay';
  /**
   * Get the associated [`Booking`].
   *
   * Requires the `booking:view` right.
   */
  booking: Booking;
  childId: Scalars['ObjectId']['output'];
  cid: Scalars['ObjectId']['output'];
  date: Scalars['NaiveDate']['output'];
  id: Scalars['ObjectId']['output'];
  iid: Scalars['ObjectId']['output'];
  oid: Scalars['ObjectId']['output'];
  type: BookingTypeEnum;
};

/** Input for a `setBookingDays` mutation */
export type BookingDayInput = {
  SHORT_TIME?: Array<Scalars['NaiveDate']['input']>;
  UNSET?: Array<Scalars['NaiveDate']['input']>;
  VACATION_1?: Array<Scalars['NaiveDate']['input']>;
  VACATION_2?: Array<Scalars['NaiveDate']['input']>;
  VACATION_3?: Array<Scalars['NaiveDate']['input']>;
};

/** Result of a `setBookingDays` mutation */
export type BookingDayResult = {
  __typename?: 'BookingDayResult';
  shortTime: Array<Scalars['NaiveDate']['output']>;
  unset: Array<Scalars['NaiveDate']['output']>;
  vacation1: Array<Scalars['NaiveDate']['output']>;
  vacation2: Array<Scalars['NaiveDate']['output']>;
  vacation3: Array<Scalars['NaiveDate']['output']>;
};

/** As GraphQL input type, only provide one of the fields */
export type BookingDays = AccordingToCalendar | AccordingToOpeningDays | ManuallySet;

export enum BookingDaysEnum {
  AccordingToCalendar = 'ACCORDING_TO_CALENDAR',
  AccordingToOpeningDays = 'ACCORDING_TO_OPENING_DAYS',
  ManuallySet = 'MANUALLY_SET'
}

/** As GraphQL input type, only provide one of the fields */
export type BookingDaysInput = {
  accordingToCalendar?: InputMaybe<AccordingToCalendarInput>;
  accordingToOpeningDays?: InputMaybe<AccordingToOpeningDaysInput>;
  manuallySet?: InputMaybe<ManuallySetInput>;
};

export type BookingList = {
  __typename?: 'BookingList';
  items: Array<Booking>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

/** Buchungszeit */
export enum BookingTime {
  /** "Keine Zeit" / "Keine Belegung" / <= 1 Stunde */
  Nil = 'NIL',
  /** \>1‒2 Stunden */
  Y00 = 'Y00',
  /** \>2‒3 Stunden */
  Y01 = 'Y01',
  /** \>3‒4 Stunden */
  Y02 = 'Y02',
  /** \>4‒5 Stunden */
  Y03 = 'Y03',
  /** \>5‒6 Stunden */
  Y04 = 'Y04',
  /** \>6‒7 Stunden */
  Y05 = 'Y05',
  /** \>7‒8 Stunden */
  Y06 = 'Y06',
  /** \>8‒9 Stunden */
  Y07 = 'Y07',
  /** \>9 Stunden */
  Y08 = 'Y08'
}

export enum BookingTimeCalculationBase {
  DistributeDifferenceOfVacationAndStandardBooking = 'DISTRIBUTE_DIFFERENCE_OF_VACATION_AND_STANDARD_BOOKING',
  OnlyStandardBookings = 'ONLY_STANDARD_BOOKINGS',
  OnlyVacationBookings = 'ONLY_VACATION_BOOKINGS',
  StandardBookingsAndVacationBookingsYearEnd = 'STANDARD_BOOKINGS_AND_VACATION_BOOKINGS_YEAR_END'
}

export enum BookingTimeCategory {
  Eight = 'EIGHT',
  Eleven = 'ELEVEN',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  One = 'ONE',
  Seven = 'SEVEN',
  Six = 'SIX',
  Ten = 'TEN',
  Three = 'THREE',
  Twelve = 'TWELVE',
  Two = 'TWO',
  Zero = 'ZERO'
}

export type BookingTimeRelatedAmount = {
  __typename?: 'BookingTimeRelatedAmount';
  /** >8-9h */
  eight?: Maybe<Scalars['Float']['output']>;
  /** >11-12h */
  eleven?: Maybe<Scalars['Float']['output']>;
  /** >5-6h */
  five?: Maybe<Scalars['Float']['output']>;
  /** >4-5h */
  four?: Maybe<Scalars['Float']['output']>;
  /** >9-10h */
  nine?: Maybe<Scalars['Float']['output']>;
  /** >1-2h */
  one?: Maybe<Scalars['Float']['output']>;
  /** >7-8h */
  seven?: Maybe<Scalars['Float']['output']>;
  /** >6-7h */
  six?: Maybe<Scalars['Float']['output']>;
  /** >10-11h */
  ten?: Maybe<Scalars['Float']['output']>;
  /** >3-4h */
  three?: Maybe<Scalars['Float']['output']>;
  /** >12h */
  twelve?: Maybe<Scalars['Float']['output']>;
  /** >2-3h */
  two?: Maybe<Scalars['Float']['output']>;
};

export type BookingTimeRelatedAmountInput = {
  /** >8-9h */
  eight?: InputMaybe<Scalars['Float']['input']>;
  /** >11-12h */
  eleven?: InputMaybe<Scalars['Float']['input']>;
  /** >5-6h */
  five?: InputMaybe<Scalars['Float']['input']>;
  /** >4-5h */
  four?: InputMaybe<Scalars['Float']['input']>;
  /** >9-10h */
  nine?: InputMaybe<Scalars['Float']['input']>;
  /** >1-2h */
  one?: InputMaybe<Scalars['Float']['input']>;
  /** >7-8h */
  seven?: InputMaybe<Scalars['Float']['input']>;
  /** >6-7h */
  six?: InputMaybe<Scalars['Float']['input']>;
  /** >10-11h */
  ten?: InputMaybe<Scalars['Float']['input']>;
  /** >3-4h */
  three?: InputMaybe<Scalars['Float']['input']>;
  /** >12h */
  twelve?: InputMaybe<Scalars['Float']['input']>;
  /** >2-3h */
  two?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * A model for the booking time table.
 *
 * To update a day in the booking times table, you specify the whole day you want to update, both `am` and `pm` field.
 * You cannot change only one time span without changing the other.
 * If we allowed for this, it would be hard to validate whether the new time spans are in order.
 * If you don't want to change a day, simply leave it out `{}` or set it to `null` like `{ "mo": null }`.
 * If you want to delete a day, specify it an leave out the fields `{"mo": { } }` or set them to `null` like `{ "mo": { "am": null, "pm": null } }`.
 * `{ "mo": { "am": null } }` is also allowed and deletes both time spans.
 */
export type BookingTimes = {
  __typename?: 'BookingTimes';
  comments?: Maybe<Scalars['String']['output']>;
  fr: AmPm;
  mo: AmPm;
  th: AmPm;
  tu: AmPm;
  we: AmPm;
};

/**
 * A model for the booking time table.
 *
 * To update a day in the booking times table, you specify the whole day you want to update, both `am` and `pm` field.
 * You cannot change only one time span without changing the other.
 * If we allowed for this, it would be hard to validate whether the new time spans are in order.
 * If you don't want to change a day, simply leave it out `{}` or set it to `null` like `{ "mo": null }`.
 * If you want to delete a day, specify it an leave out the fields `{"mo": { } }` or set them to `null` like `{ "mo": { "am": null, "pm": null } }`.
 * `{ "mo": { "am": null } }` is also allowed and deletes both time spans.
 */
export type BookingTimesInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  fr?: AmPmInput;
  mo?: AmPmInput;
  th?: AmPmInput;
  tu?: AmPmInput;
  we?: AmPmInput;
};

/** Helper enum for better ergonomics in the frontend */
export enum BookingTypeEnum {
  Alternative_1 = 'ALTERNATIVE_1',
  Alternative_2 = 'ALTERNATIVE_2',
  ShortTime = 'SHORT_TIME',
  Standard = 'STANDARD',
  Vacation_1 = 'VACATION_1',
  Vacation_2 = 'VACATION_2',
  Vacation_3 = 'VACATION_3'
}

/** As GraphQL input only provide one of the fields */
export type BookingTypeObject = Alternative1 | Alternative2 | ShortTime | Standard | Vacation1 | Vacation2 | Vacation3;

/** As GraphQL input only provide one of the fields */
export type BookingTypeObjectInput = {
  /** "Alternativbuchung-1" */
  alternative1?: InputMaybe<Alternative1Input>;
  /** "Alternativbuchung-2" */
  alternative2?: InputMaybe<Alternative2Input>;
  /** "Kurzzeitbuchung" */
  shortTime?: InputMaybe<ShortTimeInput>;
  /** "Standard-/Regelbuchung" */
  standard?: InputMaybe<StandardInput>;
  /** "Ferienbuchung-1" */
  vacation1?: InputMaybe<Vacation1Input>;
  /** "Ferienbuchung-2" */
  vacation2?: InputMaybe<Vacation2Input>;
  /** "Ferienbuchung-3" */
  vacation3?: InputMaybe<Vacation3Input>;
};

export type ByInstitution = {
  __typename?: 'ByInstitution';
  at: Scalars['NaiveDate']['output'];
};

export type ByInstitutionInput = {
  at: Scalars['NaiveDate']['input'];
};

export type ByParents = {
  __typename?: 'ByParents';
  at: Scalars['NaiveDate']['output'];
};

export type ByParentsInput = {
  at: Scalars['NaiveDate']['input'];
};

/** An owned version of an RcObject, used to send to the frontend to add data such as `id`, `organization`, `institution` and `linked_to`. */
export type Category = {
  __typename?: 'Category';
  abbreviation?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  /** Get [Institutions](Institution) this object is linked to. */
  linkedTo: Array<Institution>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
};

export type CategoryList = {
  __typename?: 'CategoryList';
  items: Array<Category>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type Characteristic = {
  __typename?: 'Characteristic';
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
};

export type CharacteristicList = {
  __typename?: 'CharacteristicList';
  items: Array<Characteristic>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type Child = {
  __typename?: 'Child';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<SimpleAddress>;
  /** Get the associated [`Addresses`](Address). */
  addresses?: Maybe<Array<ChildAddress>>;
  allergies?: Maybe<Array<Scalars['String']['output']>>;
  allowedToGoHomeAlone: Scalars['Boolean']['output'];
  altChildId?: Maybe<Scalars['String']['output']>;
  birth: Birth;
  /** Get the associated [`Characteristic`](Characteristic). */
  characteristics?: Maybe<Array<ChildCharacteristic>>;
  childId?: Maybe<Scalars['Int']['output']>;
  collectorNotes?: Maybe<Scalars['String']['output']>;
  collectors?: Maybe<Array<Collector>>;
  contact?: Maybe<Contact>;
  /**
   * Get the associated [`Contracts`](Contract).
   *
   * Requires rights to the `Contract` resource.
   */
  contracts: Array<Contract>;
  created: Modification;
  /**
   * Get the associated [`custodies`](CustodianChild).
   *
   * Requires rights to the `child` resource.
   */
  custodies: Array<CustodianChild>;
  debtorNumber: Scalars['Int']['output'];
  disability?: Maybe<Disability>;
  emergencyMeasures?: Maybe<Scalars['String']['output']>;
  externalSiblings?: Maybe<Array<ExternalSibling>>;
  financialAccountingData: FinancialAccountingData;
  healthInsurance?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  person: Person;
  pictureId?: Maybe<Scalars['String']['output']>;
  previousInstitutions?: Maybe<Array<Scalars['String']['output']>>;
  remarks?: Maybe<Scalars['String']['output']>;
  /** Get the associated [`Siblings`](Child). */
  siblings: Array<Child>;
  symbol?: Maybe<Scalars['String']['output']>;
  vaccination?: Maybe<Vaccination>;
  visitingNotes?: Maybe<Scalars['String']['output']>;
};

export type ChildAddress = {
  __typename?: 'ChildAddress';
  /**
   * Get the [`Address`] object.
   *
   * Requires rights to the `address` resource.
   */
  address?: Maybe<Address>;
  addressId: Scalars['ObjectId']['output'];
  childId: Scalars['ObjectId']['output'];
  created: Modification;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type ChildCharacteristic = {
  __typename?: 'ChildCharacteristic';
  /**
   * Get the associated [`Characteristic`] object.
   *
   * Requires rights to the `characteristic` resource.
   */
  characteristic?: Maybe<Characteristic>;
  characteristicId: Scalars['ObjectId']['output'];
  /**
   * Get the associated [`Child`] object.
   *
   * Requires rights to the `child` resource.
   */
  child?: Maybe<Child>;
  childId: Scalars['ObjectId']['output'];
  created: Modification;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type ChildCharacteristicBulkInput = {
  characteristicIds: Array<Scalars['StrictEntityId']['input']>;
  childIds: Array<Scalars['StrictEntityId']['input']>;
};

export type ChildList = {
  __typename?: 'ChildList';
  items: Array<Child>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ChildPresences = {
  __typename?: 'ChildPresences';
  child: Child;
  presences: Array<Presence>;
};

export enum ChildSubsidyState {
  /** Kein Status (nur für "Keine Belegung") */
  Nil = 'NIL',
  /** Kind - Regelförderung */
  X00 = 'X00',
  /** Kind - Schulkind */
  X01 = 'X01',
  /** Kind - 0 bis unter 3 */
  X02 = 'X02',
  /** Migration - Regelförderung */
  X03 = 'X03',
  /** Migration - Schulkind */
  X04 = 'X04',
  /** Migration - 0 bis unter 3 */
  X05 = 'X05',
  /** Behinderung - Regelförderung */
  X06 = 'X06',
  /** Behinderung - Schulkind */
  X07 = 'X07',
  /** Behinderung - 0 bis unter 3 */
  X08 = 'X08',
  /** Behinderung - Migration */
  X09 = 'X09'
}

export type Collector = {
  __typename?: 'Collector';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/** An owned version of an RcObject, used to send to the frontend to add data such as `id`, `organization`, `institution` and `linked_to`. */
export type Commune = {
  __typename?: 'Commune';
  additionalAddress?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<SimpleAddress>;
  comments?: Maybe<Scalars['String']['output']>;
  communeKey: Scalars['String']['output'];
  contactPerson?: Maybe<ContactPerson>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  /** Get [Institutions](Institution) this object is linked to. */
  linkedTo: Array<Institution>;
  n: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CommuneList = {
  __typename?: 'CommuneList';
  items: Array<Commune>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ConfigKeyLevel = {
  __typename?: 'ConfigKeyLevel';
  visible: Scalars['Boolean']['output'];
  writable: Scalars['Boolean']['output'];
};

export type ConfigKeyMeta = {
  __typename?: 'ConfigKeyMeta';
  customer: ConfigKeyLevel;
  institution: ConfigKeyLevel;
  organization: ConfigKeyLevel;
  system: ConfigKeyLevel;
  type: ConfigKeyType;
};

export enum ConfigKeyType {
  Boolean = 'BOOLEAN',
  Enum = 'ENUM',
  Number = 'NUMBER',
  Password = 'PASSWORD',
  String = 'STRING'
}

export type Configuration = {
  __typename?: 'Configuration';
  level: ConfigurationLevel;
  values: Scalars['JSONObject']['output'];
};

export enum ConfigurationLevel {
  Customer = 'customer',
  Institution = 'institution',
  Organization = 'organization',
  System = 'system'
}

export type ConfigurationMeta = {
  __typename?: 'ConfigurationMeta';
  level: ConfigurationMetaLevel;
  values: Scalars['JSONObject']['output'];
};

export enum ConfigurationMetaLevel {
  Customer = 'customer',
  Organization = 'organization',
  System = 'system'
}

export type ConfigurationSchema = {
  __typename?: 'ConfigurationSchema';
  AltKindId: ConfigKeyMeta;
  AltKindIdMuster: ConfigKeyMeta;
  AltPersId: ConfigKeyMeta;
  Arbeitgeber: ConfigKeyMeta;
  AssumptionDay: ConfigKeyMeta;
  AugsburgerPeaceFestival: ConfigKeyMeta;
  EditAltKindId: ConfigKeyMeta;
  KibigExportCalendarYear: ConfigKeyMeta;
  KibigKey: ConfigKeyMeta;
  KibigKindIdMuster: ConfigKeyMeta;
  KibigKindNameMuster: ConfigKeyMeta;
  KibigMabIdMuster: ConfigKeyMeta;
  KindIDBis: ConfigKeyMeta;
  KindIDManuell: ConfigKeyMeta;
  KindIDVon: ConfigKeyMeta;
  MabIDManuell: ConfigKeyMeta;
  MitarbeiterMasernschutz: ConfigKeyMeta;
  SepaCreationStrategy: ConfigKeyMeta;
  YearType: ConfigKeyMeta;
};

/** If used as an input argument in GraphQL, exactly one of the fields must be provided. */
export type Confirmed = ByInstitution | ByParents;

/** If used as an input argument in GraphQL, exactly one of the fields must be provided. */
export type ConfirmedInput = {
  byInstitution?: InputMaybe<ByInstitutionInput>;
  byParents?: InputMaybe<ByParentsInput>;
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  letterSalutation?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneMobile?: Maybe<Scalars['String']['output']>;
  phoneWork?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  email2?: InputMaybe<Scalars['String']['input']>;
  letterSalutation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  phoneWork?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  address?: Maybe<SimpleAddress>;
  contact?: Maybe<Contact>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ContactPersonInput = {
  address?: InputMaybe<SimpleAddressInput>;
  contact?: InputMaybe<ContactInput>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Filter to restrict a query
 *
 * Usage:
 * - Specify customer, if you want to filter for a customer.
 * - Specify both customer and organization, if you want to filter for an organization.
 * - Specify all of the three fields, if you want to filter for an institution.
 */
export type ContextFilter = {
  customer?: InputMaybe<Scalars['ObjectId']['input']>;
  institution?: InputMaybe<Scalars['ObjectId']['input']>;
  organization?: InputMaybe<Scalars['ObjectId']['input']>;
};

/**
 * Oneof input object in GraphQL
 * Oneof input objects requires have exactly one field
 */
export type ContextFilterInput = {
  customerFilter?: InputMaybe<CustomerFilter>;
  institutionFilter?: InputMaybe<InstitutionFilter>;
  organizationFilter?: InputMaybe<OrganizationFilter>;
};

export type Contract = {
  __typename?: 'Contract';
  /**
   * Get the associated [`Booking`](Booking)s.
   *
   * Requires rights to the `booking` resource.
   */
  bookings: Array<Booking>;
  /**
   * Get the associated [`Child`]
   *
   * Requires access to the `child` resource
   */
  child: Child;
  childId: Scalars['ObjectId']['output'];
  /** Find the most recent creation date */
  contractCreationDate?: Maybe<Scalars['NaiveDate']['output']>;
  /**
   * Get the associated [`ContractFeeType`]s
   *
   * Requires access to the [Fee](ResourceType::Fee) resource.
   */
  contractFeeTypes: Array<ContractFeeType>;
  /** Find the most recent signing date */
  contractSigningDate?: Maybe<Scalars['NaiveDate']['output']>;
  created: Modification;
  /** Get the associated [debtors.](Debtor) */
  debtors?: Maybe<Array<Debtor>>;
  endOfContract?: Maybe<Scalars['NaiveDate']['output']>;
  /**
   * Get the associated [`FeeTicket`]s.
   *
   * Requires rights to the [Fee](ResourceType::Fee) resource.
   */
  feeTickets: Array<FeeTicket>;
  /** Get the associated [`Group`](GroupContract)s. */
  groups: Array<GroupContract>;
  id: Scalars['LongEntityId']['output'];
  /** Get the associated [main debtors.](MainDebtor) */
  mainDebtors?: Maybe<Array<MainDebtor>>;
  modified?: Maybe<Modification>;
  registrationDate: Scalars['NaiveDate']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  startOfContract?: Maybe<Scalars['NaiveDate']['output']>;
  state: ContractState;
  /** Assume ordered by date and not empty */
  stateHistory: Array<HistoryEntry>;
};

export type ContractFeeType = {
  __typename?: 'ContractFeeType';
  /**
   * Get the associated [`AccountingGroup`].
   *
   * Requires rights to the [Fee](ResourceType::Fee) resource.
   */
  accountingGroup: AccountingGroup;
  created: Modification;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Get the associated [`FeeType`] object.
   *
   * Requires rights to the [Fee](ResourceType::Fee) resource.
   */
  feeType: FeeType;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['DateTime']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

/** If used as an input argument in GraphQL, exactly one of the fields must be provided. */
export type ContractState = Contracted | Open | Queued | Rejected | Reserved | Terminated;

/** If used as an input argument in GraphQL, exactly one of the fields must be provided. */
export type ContractStateInput = {
  contracted?: InputMaybe<ContractedInput>;
  open?: InputMaybe<OpenInput>;
  queued?: InputMaybe<QueuedInput>;
  rejected?: InputMaybe<RejectedInput>;
  reserved?: InputMaybe<ReservedInput>;
  terminated?: InputMaybe<TerminatedInput>;
};

export type Contracted = {
  __typename?: 'Contracted';
  substate?: Maybe<Substate>;
};

export type ContractedInput = {
  substate?: InputMaybe<SubstateInput>;
};

/** As input type, this is a "Oneof" object */
export type ContributionAmount = BookingTimeRelatedAmount | SimpleAmount;

/** As input type, this is a "Oneof" object */
export type ContributionAmountInput = {
  bookingTimeRelated?: InputMaybe<BookingTimeRelatedAmountInput>;
  simple?: InputMaybe<SimpleAmountInput>;
};

export type ContributionRate = {
  __typename?: 'ContributionRate';
  amount: ContributionAmount;
  amountBased: Scalars['Boolean']['output'];
  bookingTimeCalculationBase?: Maybe<BookingTimeCalculationBase>;
  factorCalculationBase?: Maybe<FactorCalculationBase>;
  from: Scalars['NaiveDate']['output'];
  isEligibleForGrant: Scalars['Boolean']['output'];
  to?: Maybe<Scalars['NaiveDate']['output']>;
  vat: Scalars['Float']['output'];
};

export type ContributionRateInput = {
  amount: ContributionAmountInput;
  amountBased: Scalars['Boolean']['input'];
  bookingTimeCalculationBase?: InputMaybe<BookingTimeCalculationBase>;
  factorCalculationBase?: InputMaybe<FactorCalculationBase>;
  from: Scalars['NaiveDate']['input'];
  isEligibleForGrant: Scalars['Boolean']['input'];
  to?: InputMaybe<Scalars['NaiveDate']['input']>;
  vat?: Scalars['Float']['input'];
};

export enum ContributionType {
  AmountPerUnit = 'AMOUNT_PER_UNIT',
  Percentage = 'PERCENTAGE',
  RemainingAmount = 'REMAINING_AMOUNT',
  TotalAmount = 'TOTAL_AMOUNT'
}

export type CreateAccountingGroupInput = {
  /**
   * "Abrechnen zum"
   * -1 represents "monatsletzten".
   * 0 represents "null".
   * 1 up to 31 represents the date of the month.
   */
  accountAtDayOfMonth?: Scalars['Int']['input'];
  /** "Beitragsschema-ID" */
  accountingGroupId?: InputMaybe<Scalars['String']['input']>;
  /** "Bereich" */
  category?: InputMaybe<GeneralFeeCategory>;
  /** "monatliche Erhebung: Anzahl Monate" */
  months?: InputMaybe<Months>;
  /** "Bezeichnung" */
  name: Scalars['String']['input'];
  /** "Beitragserhebung" */
  repetition?: InputMaybe<Repetition>;
  standard?: Scalars['Boolean']['input'];
};

export type CreateAccountingRunInput = {
  accountingDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  accountingGroupId: Scalars['StrictEntityId']['input'];
  fees: Array<FeeItemInput>;
  receiptDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  receiptDueDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  yearMonth: Scalars['YearMonth']['input'];
};

export type CreateAddressCategoryInput = {
  addressId: Scalars['StrictEntityId']['input'];
  categoryId: Scalars['StrictEntityId']['input'];
};

export type CreateAddressInput = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  bankInstitution?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['Bic']['input']>;
  birthdate?: InputMaybe<Scalars['NaiveDate']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  collectiveInvoice?: Scalars['Boolean']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  debtorNumber?: InputMaybe<Scalars['Int']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  doctor?: InputMaybe<Scalars['Boolean']['input']>;
  employer?: InputMaybe<Scalars['Boolean']['input']>;
  externalAddress?: InputMaybe<Scalars['Boolean']['input']>;
  externalPayer?: InputMaybe<Scalars['Boolean']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  financialAccountingData?: FinancialAccountingDataInput;
  firstname?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['Iban']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  otherAddress?: InputMaybe<Scalars['Boolean']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  specialService?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  volunteer?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerDescription?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAnalysisInput = {
  children?: Array<AnalysisChildInput>;
  createdFromCurrentData?: Scalars['Boolean']['input'];
  employees?: Array<AnalysisEmployeeInput>;
  fundingAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  options?: CreateAnalysisOptionsInput;
  remark?: InputMaybe<Scalars['String']['input']>;
  staffingRatio?: InputMaybe<Scalars['Float']['input']>;
  year: YearInput;
};

export type CreateAnalysisOptionsInput = {
  districtSubsidy?: InputMaybe<Region>;
  factorIncrease?: InputMaybe<CreateFactorIncreaseInput>;
  rural?: InputMaybe<RuralKita>;
};

export type CreateAppointmentChildInput = {
  appointmentId: Scalars['StrictEntityId']['input'];
  childId: Scalars['StrictEntityId']['input'];
};

export type CreateAppointmentEmployeeInput = {
  appointmentId: Scalars['StrictEntityId']['input'];
  employeeId: Scalars['StrictEntityId']['input'];
};

export type CreateAppointmentInput = {
  absence: Scalars['Boolean']['input'];
  from: Scalars['DateTime']['input'];
  fullDay: Scalars['Boolean']['input'];
  subject: Scalars['String']['input'];
  subtype?: InputMaybe<AppointmentType>;
  text?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  type: AppointmentType;
};

export type CreateBankInput = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  bankInstitution?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['Bic']['input']>;
  iban?: InputMaybe<Scalars['Iban']['input']>;
};

export type CreateBookingInput = {
  assistedIntegration?: Scalars['Boolean']['input'];
  contractId: Scalars['StrictEntityId']['input'];
  districtSubsidy?: Scalars['Boolean']['input'];
  exceptionForParentalFeeSubsidy?: Scalars['Boolean']['input'];
  exceptionForSubsidy?: Scalars['Boolean']['input'];
  from: Scalars['NaiveDate']['input'];
  institutionSectionId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  isPreSchooler?: Scalars['Boolean']['input'];
  isSchoolChild?: Scalars['Boolean']['input'];
  lunch?: Scalars['Boolean']['input'];
  migration?: Scalars['Boolean']['input'];
  nurseryChild?: Scalars['Boolean']['input'];
  nurseryChildException?: Scalars['Boolean']['input'];
  preCourse?: Scalars['Boolean']['input'];
  preSchooler?: InputMaybe<Enrollment>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  schoolData?: InputMaybe<CreateSchoolDataInput>;
  timeFactor: CreateTimeFactorDataInput;
  timeFactorManuallySet: Scalars['Boolean']['input'];
  times?: BookingTimesInput;
  to?: InputMaybe<Scalars['NaiveDate']['input']>;
  typeObject?: BookingTypeObjectInput;
};

export type CreateCategoryInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCharacteristicInput = {
  name: Scalars['String']['input'];
};

export type CreateChildAddressInput = {
  addressId: Scalars['StrictEntityId']['input'];
  childId: Scalars['StrictEntityId']['input'];
};

export type CreateChildCharacteristicInput = {
  characteristicId: Scalars['StrictEntityId']['input'];
  childId: Scalars['StrictEntityId']['input'];
};

export type CreateChildInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<SimpleAddressInput>;
  allergies?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedToGoHomeAlone: Scalars['Boolean']['input'];
  altChildId?: InputMaybe<Scalars['String']['input']>;
  birth: BirthInput;
  childId?: InputMaybe<Scalars['Int']['input']>;
  collectorNotes?: InputMaybe<Scalars['String']['input']>;
  collectors?: InputMaybe<Array<CreateCollectorInput>>;
  contact?: InputMaybe<ContactInput>;
  debtorNumber?: InputMaybe<Scalars['Int']['input']>;
  disability?: InputMaybe<CreateDisabilityInput>;
  emergencyMeasures?: InputMaybe<Scalars['String']['input']>;
  externalSiblings?: InputMaybe<Array<ExternalSiblingInput>>;
  financialAccountingData?: FinancialAccountingDataInput;
  healthInsurance?: InputMaybe<Scalars['String']['input']>;
  person: PersonInput;
  pictureId?: InputMaybe<Scalars['String']['input']>;
  previousInstitutions?: InputMaybe<Array<Scalars['String']['input']>>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  vaccination?: InputMaybe<CreateVaccinationInput>;
  visitingNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCollectorInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommuneInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<SimpleAddressInput>;
  comments?: InputMaybe<Scalars['String']['input']>;
  communeKey: Scalars['String']['input'];
  contactPerson?: InputMaybe<ContactPersonInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractFeeTypeInput = {
  accountingGroupId: Scalars['StrictEntityId']['input'];
  contractId: Scalars['StrictEntityId']['input'];
  endDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  feeTypeId: Scalars['StrictEntityId']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['NaiveDate']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractInput = {
  childId: Scalars['ObjectId']['input'];
  endOfContract?: InputMaybe<Scalars['NaiveDate']['input']>;
  registrationDate: Scalars['NaiveDate']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  startOfContract?: InputMaybe<Scalars['NaiveDate']['input']>;
};

export type CreateCustodianCategoryInput = {
  categoryId: Scalars['StrictEntityId']['input'];
  custodianId: Scalars['StrictEntityId']['input'];
};

export type CreateCustodianChildInput = {
  /** "personensorgeberechtigt" */
  allowedToCare?: Scalars['Boolean']['input'];
  /** "alleinerziehend" */
  alone?: Scalars['Boolean']['input'];
  /** "Alleinsorgeberechtigt" */
  aloneCare?: Scalars['Boolean']['input'];
  childId: Scalars['ObjectId']['input'];
  custodianId: Scalars['ObjectId']['input'];
  /** "Post" */
  post?: Scalars['Boolean']['input'];
  relation?: InputMaybe<Relation>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  sepaMandateId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type CreateCustodianInput = {
  address?: SimpleAddressInput;
  bankDetails?: CreateBankInput;
  birth?: BirthInput;
  /** "Sammelrechnung" flag to determine the receipt aggregation */
  collectiveInvoice?: Scalars['Boolean']['input'];
  contact?: ContactInput;
  debtorNumber?: InputMaybe<Scalars['Int']['input']>;
  employerId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  financialAccountingData?: FinancialAccountingDataInput;
  honoraryPost?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  person: PersonInput;
  profession?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDebtorAgreementContractFeeTypeInput = {
  contractFeeTypeId: Scalars['StrictEntityId']['input'];
  contributionType: ContributionType;
  contributionValue: Scalars['Float']['input'];
  debtorAgreementId: Scalars['StrictEntityId']['input'];
};

export type CreateDebtorAgreementInput = {
  debtorId: Scalars['StrictEntityId']['input'];
  endDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  paymentMethod: PaymentMethod;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['NaiveDate']['input'];
  totalMaxAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateDebtorInput = {
  addressId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  contractId: Scalars['StrictEntityId']['input'];
  custodianChildId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  youthWelfareOfficeId?: InputMaybe<Scalars['StrictEntityId']['input']>;
};

export type CreateDisabilityInput = {
  certified: Scalars['Boolean']['input'];
  certifiedUntil?: InputMaybe<Scalars['NaiveDate']['input']>;
  intellectual: Scalars['Boolean']['input'];
  mental: Scalars['Boolean']['input'];
  physical: Scalars['Boolean']['input'];
};

export type CreateEmployeeCategoryInput = {
  categoryId: Scalars['StrictEntityId']['input'];
  employeeId: Scalars['StrictEntityId']['input'];
};

export type CreateEmployeeGroupInput = {
  employeeId: Scalars['ObjectId']['input'];
  from?: InputMaybe<Scalars['NaiveDate']['input']>;
  groupId: Scalars['ObjectId']['input'];
  role: GroupRole;
  to?: InputMaybe<Scalars['NaiveDate']['input']>;
};

export type CreateEmployeeInput = {
  address?: InputMaybe<SimpleAddressInput>;
  birth?: InputMaybe<BirthInput>;
  certificateOfGoodConduct?: InputMaybe<Scalars['NaiveDate']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<ContactInput>;
  education?: InputMaybe<Scalars['String']['input']>;
  educationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  kitalinoExport?: InputMaybe<Scalars['Boolean']['input']>;
  movement: MovementInput;
  order?: InputMaybe<Scalars['Int']['input']>;
  person: PersonInput;
  personnelNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  statisticsEducation?: InputMaybe<Scalars['String']['input']>;
  statisticsPositionType?: InputMaybe<Scalars['String']['input']>;
  vaccination?: InputMaybe<CreateVaccinationInput>;
};

export type CreateEmployeeQualificationInput = {
  employeeId: Scalars['StrictEntityId']['input'];
  from: Scalars['NaiveDate']['input'];
  qualificationId: Scalars['StrictEntityId']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  resubmission?: InputMaybe<Scalars['NaiveDate']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['NaiveDate']['input']>;
};

/**
 * Only one value between `position` and `interruption` is allowed.
 * To uphold this invariant, the `CreateEmploymentInputValidator` must be used whereever `CreateEmploymentInput` is used as an input.
 */
export type CreateEmploymentInput = {
  additionalStaff?: InputMaybe<Scalars['Boolean']['input']>;
  beginMode?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  creditableWorkingHours?: InputMaybe<Scalars['Float']['input']>;
  employeeId: Scalars['ObjectId']['input'];
  endMode?: InputMaybe<Scalars['String']['input']>;
  excludedFromStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  institutionSectionWorkingHours?: Array<SectionTimeInput>;
  interruption?: InputMaybe<Interruption>;
  movement: MovementInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Position>;
  statisticsAreaWorkingHours?: Array<StatisticsAreaWorkingHoursInput>;
  times?: InputMaybe<TimesInput>;
  vacationDays?: InputMaybe<Scalars['Int']['input']>;
  workingHours?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateFactorIncreaseInput = {
  number: Scalars['Float']['input'];
  type: FactorType;
};

export type CreateFeeDebtorInput = {
  amount: Scalars['Float']['input'];
  bic?: InputMaybe<Scalars['Bic']['input']>;
  debtorId: Scalars['StrictEntityId']['input'];
  iban?: InputMaybe<Scalars['Iban']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
  /** "Aktenzeichen" */
  reference?: InputMaybe<Scalars['String']['input']>;
  sepaMandateCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sepaMandateReference?: InputMaybe<Scalars['String']['input']>;
  status: FeeDebtorAccountedStatus;
};

export type CreateFeeDraftFeeTypeInput = {
  defaultAccountingGroupId: Scalars['ObjectId']['input'];
  feeDraftId: Scalars['ObjectId']['input'];
  feeTypeId: Scalars['ObjectId']['input'];
};

export type CreateFeeDraftInput = {
  name: Scalars['String']['input'];
  standard?: Scalars['Boolean']['input'];
};

export type CreateFeeInput = {
  childId: Scalars['StrictEntityId']['input'];
  contractFeeTypeId: Scalars['StrictEntityId']['input'];
  debtors: Array<CreateFeeDebtorInput>;
  feeTicketId: Scalars['StrictEntityId']['input'];
  /** "accounting.status" */
  status: AccountedStatus;
  text: Scalars['String']['input'];
  value: CreateFeeValueInput;
};

export type CreateFeeTicketInput = {
  accountedStatus: AccountedStatus;
  contractId: Scalars['StrictEntityId']['input'];
  deprecated?: Scalars['Boolean']['input'];
  version: Scalars['Int']['input'];
  yearMonth: Scalars['YearMonth']['input'];
};

export type CreateFeeTypeInput = {
  active?: Scalars['Boolean']['input'];
  category: FeeCategory;
  contributionRates?: Array<ContributionRateInput>;
  /**
   * "Beitragsschema"
   * Refers to an accounting group
   */
  defaultAccountingGroupId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  fibuData?: InputMaybe<Scalars['String']['input']>;
  generalCategory?: InputMaybe<GeneralFeeCategory>;
  /** Unique id */
  idString?: InputMaybe<Scalars['String']['input']>;
  /** Unique name */
  name: Scalars['String']['input'];
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Description with placeholders */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFeeValueInput = {
  bookingTimeCategory?: InputMaybe<BookingTimeCategory>;
  factor?: InputMaybe<Scalars['Float']['input']>;
  singleBrutto?: InputMaybe<Scalars['Float']['input']>;
  vat?: Scalars['Float']['input'];
};

export type CreateFoodTypeInput = {
  description: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type CreateGroupContractInput = {
  contractId: Scalars['StrictEntityId']['input'];
  groupId: Scalars['StrictEntityId']['input'];
  movement: MovementInput;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupInput = {
  actionGroup?: InputMaybe<Scalars['Boolean']['input']>;
  active?: Scalars['Boolean']['input'];
  careTimes?: InputMaybe<TimesInput>;
  name: Scalars['String']['input'];
  serviceColor?: InputMaybe<Scalars['String']['input']>;
  synchronized?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateInstitutionSectionInput = {
  contactPerson?: InputMaybe<ContactPersonInput>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shortname?: InputMaybe<Scalars['String']['input']>;
  type: InstitutionType;
};

export type CreateMainDebtorInput = {
  contractId: Scalars['StrictEntityId']['input'];
  custodianChildId: Scalars['StrictEntityId']['input'];
  endDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  paymentMethod: PaymentMethod;
  startDate: Scalars['NaiveDate']['input'];
};

export type CreateQualificationInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateReceiptBlockChildInput = {
  birthdate: Scalars['NaiveDate']['input'];
  childId: Scalars['StrictEntityId']['input'];
  debtorNumber: Scalars['Int']['input'];
  financialAccountingData: FinancialAccountingDataInput;
  name: Scalars['String']['input'];
};

export type CreateReceiptBlockFeeInput = {
  amounts: Array<Scalars['Float']['input']>;
  feeId: Scalars['StrictEntityId']['input'];
  originalValue: CreateFeeValueInput;
  text: Scalars['String']['input'];
};

export type CreateReceiptBlockInput = {
  child: CreateReceiptBlockChildInput;
  months: Array<CreateReceiptBlockMonthInput>;
};

export type CreateReceiptBlockMonthInput = {
  fees: Array<CreateReceiptBlockFeeInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  yearMonth: Scalars['YearMonth']['input'];
};

export type CreateReceiptDebtorInput = {
  address: SimpleAddressInput;
  collectiveInvoice: Scalars['Boolean']['input'];
  debtorId: Scalars['StrictEntityId']['input'];
  debtorNumber: Scalars['Int']['input'];
  debtorType: ReceiptDebtorType;
  financialAccountingData: FinancialAccountingDataInput;
  name: Scalars['String']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReceiptInput = {
  accountingRunId: Scalars['StrictEntityId']['input'];
  blocks: Array<CreateReceiptBlockInput>;
  date: Scalars['NaiveDate']['input'];
  debtor: CreateReceiptDebtorInput;
  n: Scalars['Int']['input'];
  paymentData: CreateReceiptPaymentDataInput;
  receiptDisplayNumber?: InputMaybe<Scalars['String']['input']>;
  yearMonth: Scalars['YearMonth']['input'];
};

export type CreateReceiptPaymentDataInput = {
  bic?: InputMaybe<Scalars['Bic']['input']>;
  iban?: InputMaybe<Scalars['Iban']['input']>;
  paymentMethod: PaymentMethod;
  sepaMandateCreatedAt?: InputMaybe<Scalars['NaiveDate']['input']>;
  sepaMandateReference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoleInput = {
  accessLevel: AccessLevel;
  name: Scalars['String']['input'];
  /** Role Id (Keycloak's group id) */
  templateRole?: InputMaybe<Scalars['RoleId']['input']>;
};

export type CreateSchoolDataInput = {
  className?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['StrictEntityId']['input'];
};

export type CreateSchoolInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<SimpleAddressInput>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSepaMandateInput = {
  custodianId: Scalars['StrictEntityId']['input'];
  n?: InputMaybe<Scalars['Int']['input']>;
  previousSepaMandateId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  sepaMandateReference: Scalars['String']['input'];
  valid?: Scalars['Boolean']['input'];
  /** If not specified, will use the current system date. */
  validFrom?: InputMaybe<Scalars['NaiveDate']['input']>;
  validTo?: InputMaybe<Scalars['NaiveDate']['input']>;
};

/**
 * Represents a service type
 *
 * Legacy name: "Dienstart"
 */
export type CreateServiceTypeInput = {
  bgcolor: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  times: TimeRangeInput;
  type: Scalars['String']['input'];
};

export type CreateSiblingAssignmentInput = {
  firstChild: Scalars['StrictEntityId']['input'];
  secondChild: Scalars['StrictEntityId']['input'];
};

export type CreateTimeFactorDataInput = {
  category: BookingTimeCategory;
  daysPerWeek?: Scalars['Int']['input'];
  hoursPerWeek?: Scalars['Float']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstname: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  kibigKey?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  requiredActions?: InputMaybe<Array<RequiredUserAction>>;
  roleId: Scalars['RoleId']['input'];
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type CreateVaccinationInput = {
  /**
   * This is date since contraindication and was called `ismmoeglab` in the
   * legacy application.
   */
  contraindicationEndDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  /** This confirms that all early diagnostics where performed. */
  earlyDiagnosticsCertified?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * This is the date of the first vaccination and was called `ism1dat` in the
   * legacy application.
   */
  firstConfirmationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  /**
   * This is the date of the last change of the vaccination status and was
   * called `ismstatdat` in the legacy application.
   */
  lastStatusUpdate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * This is the description of complications and was called `ismzweifel` in
   * the legacy application.
   */
  proofDoubts?: InputMaybe<Scalars['String']['input']>;
  /**
   * This is the date at which the vaccination was reported to the health
   * department and was called `ismmelddat` in the legacy application.
   */
  reportDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  /**
   * This is the date of the first vaccination and was called `ism2dat` in the
   * legacy application.
   */
  secondConfirmationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  /**
   * This is the vaccination status and was called `ismstatus` in the legacy
   * application.
   */
  status?: InputMaybe<VaccinationStatus>;
  /** This is the date of the tetanus vaccination. */
  tetanusVaccinationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  /**
   * This confirms the vaccination requirement is fulfilled or vaccination
   * consultation was taken.
   */
  vaccinationCertified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateYouthWelfareOfficeInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<SimpleAddressInput>;
  collectiveInvoice?: Scalars['Boolean']['input'];
  contactPerson?: InputMaybe<ContactPersonInput>;
  debtorNumber?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  financialAccountingData?: FinancialAccountingDataInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type Created = {
  __typename?: 'Created';
  at: Scalars['NaiveDate']['output'];
};

export type CreatedInput = {
  at: Scalars['NaiveDate']['input'];
};

export type Custodian = {
  __typename?: 'Custodian';
  address: SimpleAddress;
  bankDetails: Bank;
  birth: Birth;
  /** Get the associated [`Categories`](Category). */
  categories?: Maybe<Array<CustodianCategory>>;
  /** "Sammelrechnung" flag to determine the receipt aggregation */
  collectiveInvoice: Scalars['Boolean']['output'];
  contact: Contact;
  created: Modification;
  /** Get the associated [`Custodies`](CustodianChild) */
  custodies: Array<CustodianChild>;
  debtorNumber: Scalars['Int']['output'];
  /**
   * Get the associated [employer](Address).
   *
   * An employer is represented by an [Address].
   *
   * Requires rights to the `address` resource.
   */
  employer?: Maybe<Address>;
  employerId?: Maybe<Scalars['StrictEntityId']['output']>;
  financialAccountingData: FinancialAccountingData;
  honoraryPost?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  maritalStatus?: Maybe<MaritalStatus>;
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  person: Person;
  profession?: Maybe<Scalars['String']['output']>;
  /**
   * Get the associated [sepa mandates](SepaMandate).
   *
   * Requires rights to the `fee` resource.
   */
  sepaMandates: Array<SepaMandate>;
};

export type CustodianCategory = {
  __typename?: 'CustodianCategory';
  /**
   * Get the [`Category`] object.
   *
   * Requires rights to the `category` resource.
   */
  category?: Maybe<Category>;
  categoryId: Scalars['ObjectId']['output'];
  created: Modification;
  custodianId: Scalars['ObjectId']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type CustodianChild = {
  __typename?: 'CustodianChild';
  /** "personensorgeberechtigt" */
  allowedToCare: Scalars['Boolean']['output'];
  /** "alleinerziehend" */
  alone: Scalars['Boolean']['output'];
  /** "Alleinsorgeberechtigt" */
  aloneCare: Scalars['Boolean']['output'];
  /**
   * Get the associated [`Child`] object.
   *
   * Requires rights to the `child` resource.
   */
  child?: Maybe<Child>;
  childId: Scalars['ObjectId']['output'];
  created: Modification;
  /**
   * Get the associated [`Custodian`] object.
   *
   * Requires rights to the `child` resource.
   */
  custodian?: Maybe<Custodian>;
  custodianId: Scalars['ObjectId']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  /** "Post" */
  post: Scalars['Boolean']['output'];
  relation?: Maybe<Relation>;
  remarks?: Maybe<Scalars['String']['output']>;
  sepaMandate?: Maybe<SepaMandate>;
};

export type CustodianList = {
  __typename?: 'CustodianList';
  items: Array<Custodian>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  cid?: Maybe<Scalars['ObjectId']['output']>;
  created: Modification;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  name: Scalars['String']['output'];
};

/**
 * CustomerFilter is used when filtering from the perspective of a customer using no filter or from the perspective of
 * an admin filtering for a specific customer
 */
export type CustomerFilter = {
  customer: Scalars['ObjectId']['input'];
};

export type CustomerLevel = {
  cid: Scalars['Cid']['input'];
};

export type CustomerUnitLevel = {
  cid: Scalars['Cid']['input'];
  uid: Scalars['Uid']['input'];
};

export type Debtor = {
  __typename?: 'Debtor';
  /**
   * Get the associated [Address].
   *
   * Requires rights to the `address` resource.
   */
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['StrictEntityId']['output']>;
  /**
   * Get the associated [debtor agreements](DebtorAgreement).
   *
   * Requires rights to the `contract` resource.
   */
  agreements?: Maybe<Array<DebtorAgreement>>;
  /**
   * Get the associated [contract](Contract).
   *
   * Requires rights to the `contract` resource.
   */
  contract?: Maybe<Contract>;
  contractId: Scalars['StrictEntityId']['output'];
  created: Modification;
  custodianChildId?: Maybe<Scalars['StrictEntityId']['output']>;
  /**
   * Get the associated [custody](`CustodianChild`).
   *
   * Requires rights to the `child` resource.
   */
  custody?: Maybe<CustodianChild>;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  /**
   * Get the associated [youth welfare office](YouthWelfareOffice).
   *
   * Requires rights to the `youth_welfare_office` resource.
   */
  youthWelfareOffice?: Maybe<YouthWelfareOffice>;
  youthWelfareOfficeId?: Maybe<Scalars['StrictEntityId']['output']>;
};

export type DebtorAgreement = {
  __typename?: 'DebtorAgreement';
  /**
   * Get the assignments for the associated [contract fee types](DebtorAgreementContractFeeType).
   *
   * Requires rights to the `contract` resource.
   */
  contractFeeTypeAssignments?: Maybe<Array<DebtorAgreementContractFeeType>>;
  created: Modification;
  /**
   * Get the associated [debtor](Debtor).
   *
   * Requires rights to the `contract` resource.
   */
  debtor?: Maybe<Debtor>;
  debtorId: Scalars['StrictEntityId']['output'];
  endDate?: Maybe<Scalars['NaiveDate']['output']>;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  paymentMethod: PaymentMethod;
  reference?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['NaiveDate']['output'];
  totalMaxAmount?: Maybe<Scalars['Float']['output']>;
};

export type DebtorAgreementContractFeeType = {
  __typename?: 'DebtorAgreementContractFeeType';
  /**
   * Get the associated [contract fee type](`ContractFeeType`).
   *
   * Requires rights to the `contract` resource.
   */
  contractFeeType?: Maybe<ContractFeeType>;
  contractFeeTypeId: Scalars['StrictEntityId']['output'];
  contributionType: ContributionType;
  contributionValue: Scalars['Float']['output'];
  created: Modification;
  /**
   * Get the associated [debtor agreement](`DebtorAgreement`).
   *
   * Requires rights to the `contract` resource.
   */
  debtorAgreement?: Maybe<DebtorAgreement>;
  debtorAgreementId: Scalars['StrictEntityId']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type DebtorList = {
  __typename?: 'DebtorList';
  items: Array<Debtor>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type Disability = {
  __typename?: 'Disability';
  certified: Scalars['Boolean']['output'];
  certifiedUntil?: Maybe<Scalars['NaiveDate']['output']>;
  intellectual: Scalars['Boolean']['output'];
  mental: Scalars['Boolean']['output'];
  physical: Scalars['Boolean']['output'];
};

export type Employee = {
  __typename?: 'Employee';
  address?: Maybe<SimpleAddress>;
  /** Get the associated [`Appointment`](Appointment). */
  appointments?: Maybe<Array<AppointmentEmployee>>;
  birth?: Maybe<Birth>;
  /** Get the associated [`Categories`](Category). */
  categories?: Maybe<Array<EmployeeCategory>>;
  certificateOfGoodConduct?: Maybe<Scalars['NaiveDate']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  education?: Maybe<Scalars['String']['output']>;
  educationDate?: Maybe<Scalars['NaiveDate']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Get the associated [`Employment`](Employment).
   *
   * Requires rights to the `employment` resource.
   */
  employments?: Maybe<Array<Employment>>;
  /** Get the associated [`Group`](EmployeeGroup). */
  groups?: Maybe<Array<EmployeeGroup>>;
  id: Scalars['LongEntityId']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  kitalinoExport?: Maybe<Scalars['Boolean']['output']>;
  movement: Movement;
  n: Scalars['Int']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  person: Person;
  personnelNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  /** Get the associated [`Qualification`](EmployeeQualification)s. */
  qualifications?: Maybe<Array<EmployeeQualification>>;
  statisticsEducation?: Maybe<Scalars['String']['output']>;
  statisticsPositionType?: Maybe<Scalars['String']['output']>;
  vaccination?: Maybe<Vaccination>;
};

export type EmployeeCategory = {
  __typename?: 'EmployeeCategory';
  /**
   * Get the [`Category`] object.
   *
   * Requires rights to the `category` resource.
   */
  category?: Maybe<Category>;
  categoryId: Scalars['ObjectId']['output'];
  created: Modification;
  employeeId: Scalars['ObjectId']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type EmployeeGroup = {
  __typename?: 'EmployeeGroup';
  created: Modification;
  /**
   * Get the associated [`Employee`](Employee).
   *
   * Requires rights to the `employee` resource.
   */
  employee: Employee;
  employeeId: Scalars['ObjectId']['output'];
  from?: Maybe<Scalars['NaiveDate']['output']>;
  /**
   * Get the associated [`Group`](Group).
   *
   * Requires rights to the `group` resource.
   */
  group: Group;
  groupId: Scalars['ObjectId']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  role: GroupRole;
  to?: Maybe<Scalars['NaiveDate']['output']>;
};

export type EmployeeList = {
  __typename?: 'EmployeeList';
  items: Array<Employee>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type EmployeeQualification = {
  __typename?: 'EmployeeQualification';
  created: Modification;
  employeeId: Scalars['ObjectId']['output'];
  from: Scalars['NaiveDate']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  /**
   * Get the associated [`Qualification`](Qualification).
   *
   * Requires rights to the `qualification` resource.
   */
  qualification?: Maybe<Qualification>;
  qualificationId: Scalars['ObjectId']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  resubmission?: Maybe<Scalars['NaiveDate']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['NaiveDate']['output']>;
};

export enum EmployeeSubsidyStatus {
  F = 'F',
  F1 = 'F1',
  F2 = 'F2',
  F4 = 'F4',
  Fm = 'FM',
  Fw = 'FW',
  K0 = 'K0',
  K4 = 'K4',
  Kb01 = 'KB01',
  Kb02 = 'KB02',
  Kbb = 'KBB',
  Kev = 'KEV',
  None = 'NONE'
}

export type Employment = {
  __typename?: 'Employment';
  additionalStaff?: Maybe<Scalars['Boolean']['output']>;
  beginMode?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  creditableWorkingHours?: Maybe<Scalars['Float']['output']>;
  /**
   * Get the associated [`Employee`]
   *
   * Requires rights to the `employee` resource.
   */
  employee?: Maybe<Employee>;
  endMode?: Maybe<Scalars['String']['output']>;
  excludedFromStatistics?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  institutionSectionWorkingHours: Array<SectionTime>;
  interruption?: Maybe<Interruption>;
  movement: Movement;
  n: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  position?: Maybe<Position>;
  statisticsAreaWorkingHours: Array<StatisticsAreaWorkingHours>;
  times?: Maybe<Times>;
  vacationDays?: Maybe<Scalars['Int']['output']>;
  workingHours?: Maybe<Scalars['Float']['output']>;
};

export type EmploymentList = {
  __typename?: 'EmploymentList';
  items: Array<Employment>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export enum Enrollment {
  /** "zurückgestellt" */
  Postponed = 'POSTPONED',
  /** "vorzeitig" */
  Prematurely = 'PREMATURELY',
  /** "regulär" */
  Regular = 'REGULAR'
}

export type ExternalSibling = {
  __typename?: 'ExternalSibling';
  birthdate: Scalars['NaiveDate']['output'];
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
};

export type ExternalSiblingInput = {
  birthdate: Scalars['NaiveDate']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
};

export enum FactorCalculationBase {
  ExcusedAbsenceDaysInCurrentMonth = 'EXCUSED_ABSENCE_DAYS_IN_CURRENT_MONTH',
  ExcusedAbsenceDaysInPreviousMonth = 'EXCUSED_ABSENCE_DAYS_IN_PREVIOUS_MOTH',
  Manual = 'MANUAL',
  PresenceDaysInCurrentMonth = 'PRESENCE_DAYS_IN_CURRENT_MONTH',
  PresenceDaysInPreviousMonth = 'PRESENCE_DAYS_IN_PREVIOUS_MONTH'
}

export type FactorIncrease = {
  __typename?: 'FactorIncrease';
  number: Scalars['Float']['output'];
  type: FactorType;
};

export enum FactorType {
  AgBrutto = 'AG_BRUTTO',
  PlusX = 'PLUS_X'
}

export type Fee = {
  __typename?: 'Fee';
  /** "accounting.accounting run" */
  accountedByAccountingRunId?: Maybe<Scalars['ObjectId']['output']>;
  /**
   * If missing, added by user, else, by accounting run.
   * Might change when implementing accounting runs.
   * "added by"
   */
  addedByAccountingRunId?: Maybe<Scalars['ObjectId']['output']>;
  childId: Scalars['StrictEntityId']['output'];
  /**
   * Get the associated [`ContractFeeType`] object.
   *
   * Requires rights to the [Fee](ResourceType::Fee) resource.
   */
  contractFeeType: ContractFeeType;
  contractFeeTypeId: Scalars['StrictEntityId']['output'];
  created: Modification;
  debtors: Array<FeeDebtor>;
  feeTicketId: Scalars['StrictEntityId']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  /** "accounting.status" */
  status: AccountedStatus;
  text: Scalars['String']['output'];
  value: FeeValue;
};

export enum FeeCategory {
  /** "Grundbeitrag" */
  BaseFee = 'BASE_FEE',
  /** "Essen/Verpflegung" */
  Catering = 'CATERING',
  /** "Beitragszuschuss" */
  FeeGrant = 'FEE_GRANT',
  /** "Sonstige" */
  Other = 'OTHER',
  /** "Spielgeld" */
  PlayMoney = 'PLAY_MONEY'
}

export type FeeDebtor = {
  __typename?: 'FeeDebtor';
  amount: Scalars['Float']['output'];
  bic?: Maybe<Scalars['Bic']['output']>;
  debtorId: Scalars['StrictEntityId']['output'];
  iban?: Maybe<Scalars['Iban']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentMethod: PaymentMethod;
  /** "Aktenzeichen" */
  reference?: Maybe<Scalars['String']['output']>;
  sepaMandateCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  sepaMandateReference?: Maybe<Scalars['String']['output']>;
  status: FeeDebtorAccountedStatus;
};

export enum FeeDebtorAccountedStatus {
  Accounted = 'ACCOUNTED',
  Open = 'OPEN',
  Payed = 'PAYED'
}

export type FeeDraft = {
  __typename?: 'FeeDraft';
  created: Modification;
  /** Get the associated [`FeeTemplateFeeType`]s. */
  feeDraftFeeTypes?: Maybe<Array<FeeDraftFeeType>>;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  /**
   * "Bezeichnung"
   * Unique name in the context of an institution
   */
  name: Scalars['String']['output'];
  standard: Scalars['Boolean']['output'];
};

export type FeeDraftFeeType = {
  __typename?: 'FeeDraftFeeType';
  /**
   * Get the associated [`AccountingGroup`] object.
   *
   * Requires rights to the `FeeType` resource.
   */
  accountingGroup?: Maybe<AccountingGroup>;
  created: Modification;
  defaultAccountingGroupId: Scalars['ObjectId']['output'];
  feeDraftId: Scalars['ObjectId']['output'];
  /**
   * Get the associated [`FeeType`] object.
   *
   * Requires rights to the [Fee](ResourceType::Fee) resource.
   */
  feeType?: Maybe<FeeType>;
  feeTypeId: Scalars['ObjectId']['output'];
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
};

export type FeeDraftList = {
  __typename?: 'FeeDraftList';
  items: Array<FeeDraft>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type FeeItemInput = {
  childId: Scalars['ObjectId']['input'];
  contractFeeTypeId: Scalars['ObjectId']['input'];
  contractId: Scalars['ObjectId']['input'];
  debtorPortions: Array<CreateFeeDebtorInput>;
  feeTicketId?: InputMaybe<Scalars['ObjectId']['input']>;
  openFeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  text: Scalars['String']['input'];
  value: CreateFeeValueInput;
};

/** A container for monthly fees */
export type FeeTicket = {
  __typename?: 'FeeTicket';
  accountedStatus: AccountedStatus;
  /**
   * Get the associated [`Contract`].
   *
   * Requires rights to the `contract` resource.
   */
  contract: Contract;
  created: Modification;
  deprecated: Scalars['Boolean']['output'];
  fees: Array<Fee>;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  version: Scalars['Int']['output'];
  /** The year and month of the ticket */
  yearMonth: Scalars['YearMonth']['output'];
};

export type FeeType = {
  __typename?: 'FeeType';
  active: Scalars['Boolean']['output'];
  /** "Typ" */
  category: FeeCategory;
  contributionRates: Array<ContributionRate>;
  /**
   * Get the associated [`AccountingGroup`].
   *
   * Requires the `fee:view` right.
   */
  defaultAccountingGroup?: Maybe<AccountingGroup>;
  fibuData?: Maybe<Scalars['String']['output']>;
  /** "Bereich" */
  generalCategory?: Maybe<GeneralFeeCategory>;
  id: Scalars['LongEntityId']['output'];
  /** Unique id */
  idString?: Maybe<Scalars['String']['output']>;
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  n: Scalars['Int']['output'];
  /** Unique name */
  name: Scalars['String']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  shortName?: Maybe<Scalars['String']['output']>;
  /** Description with placeholders */
  text?: Maybe<Scalars['String']['output']>;
};

export type FeeTypeList = {
  __typename?: 'FeeTypeList';
  items: Array<FeeType>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type FeeValue = {
  __typename?: 'FeeValue';
  bookingTimeCategory?: Maybe<BookingTimeCategory>;
  factor?: Maybe<Scalars['Float']['output']>;
  singleBrutto?: Maybe<Scalars['Float']['output']>;
  /**
   * Caculated netto value of a single unit
   * `singleBrutto / (1 + vat)`
   */
  singleNetto?: Maybe<Scalars['Float']['output']>;
  /**
   * Caculated brutto value of the total
   * `singleBrutto * factor`
   */
  totalBrutto?: Maybe<Scalars['Float']['output']>;
  /**
   * Caculated netto value of the total
   * `(singleBrutto * factor) / (1 + vat)`
   */
  totalNetto?: Maybe<Scalars['Float']['output']>;
  vat: Scalars['Float']['output'];
};

/**
 * Data used in the "FiBu" section of the debtor dialog on the "Elternbeiträge" page.
 * It will be used for exports to subsequent financial accounting software in the future.
 *
 * This can be saved on the [`Child`](crate::schema::model::child::Child), or on the entity behind the debtor, i.e. the [`Custodian`](crate::schema::model::custodian::Custodian), the [`Employer`](crate::schema::model::address::Address) or the [`YouthWelfareOffice`](crate::schema::model::youth_welfare_office::YouthWelfareOffice).
 */
export type FinancialAccountingData = {
  __typename?: 'FinancialAccountingData';
  fadNumber?: Maybe<Scalars['String']['output']>;
  objectNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Data used in the "FiBu" section of the debtor dialog on the "Elternbeiträge" page.
 * It will be used for exports to subsequent financial accounting software in the future.
 *
 * This can be saved on the [`Child`](crate::schema::model::child::Child), or on the entity behind the debtor, i.e. the [`Custodian`](crate::schema::model::custodian::Custodian), the [`Employer`](crate::schema::model::address::Address) or the [`YouthWelfareOffice`](crate::schema::model::youth_welfare_office::YouthWelfareOffice).
 */
export type FinancialAccountingDataInput = {
  fadNumber?: InputMaybe<Scalars['String']['input']>;
  objectNumber?: InputMaybe<Scalars['String']['input']>;
};

/** An owned version of an RcObject, used to send to the frontend to add data such as `id`, `organization`, `institution` and `linked_to`. */
export type FoodType = {
  __typename?: 'FoodType';
  description: Scalars['String']['output'];
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  key: Scalars['String']['output'];
  /** Get [Institutions](Institution) this object is linked to. */
  linkedTo: Array<Institution>;
  n: Scalars['Int']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
};

export type FoodTypeList = {
  __typename?: 'FoodTypeList';
  items: Array<FoodType>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

/** The GraphQL version for [`FunctionalRole`] with named fields */
export type FunctionalPermission = {
  __typename?: 'FunctionalPermission';
  functional: FunctionalRole;
};

/** The GraphQL version for [`FunctionalRole`] with named fields */
export type FunctionalPermissionInput = {
  functional: FunctionalRole;
};

/** A model for the functional roles */
export enum FunctionalRole {
  AccountingRun = 'accounting_run',
  BaykibigExport = 'baykibig_export',
  ChildAllowSensitiveData = 'child_allow_sensitive_data',
  ChildAndYouthServicesExport = 'child_and_youth_services_export',
  Configuration = 'configuration',
  ReceiptView = 'receipt_view',
  UserAccessChange = 'user_access_change'
}

export enum GeneralFeeCategory {
  /** "Verpflegung" */
  Catering = 'CATERING',
  /** "Bildung/Betreuung" */
  Education = 'EDUCATION',
  /** "Sonstige" */
  Other = 'OTHER'
}

export type Group = {
  __typename?: 'Group';
  actionGroup?: Maybe<Scalars['Boolean']['output']>;
  active: Scalars['Boolean']['output'];
  careTimes?: Maybe<Times>;
  /** Get the associated [`Contract`](GroupContract)s. */
  contracts: Array<GroupContract>;
  created: Modification;
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  /** Get the associated [`Management`](EmployeeGroup). */
  managements?: Maybe<Array<EmployeeGroup>>;
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  serviceColor?: Maybe<Scalars['String']['output']>;
  synchronized?: Maybe<Scalars['Boolean']['output']>;
};

export type GroupContract = {
  __typename?: 'GroupContract';
  /**
   * Get the associated [`Contract`].
   *
   * Requires rights to the `contract` resource.
   */
  contract: Contract;
  /**
   * Get the associated [`Group`](Group).
   *
   * Requires rights to the `group` resource.
   */
  group: Group;
  id: Scalars['LongEntityId']['output'];
  movement: Movement;
  notes?: Maybe<Scalars['String']['output']>;
};

export type GroupList = {
  __typename?: 'GroupList';
  items: Array<Group>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export enum GroupRole {
  /** Leiter */
  Manager = 'manager',
  /** Betreuer */
  Supervisor = 'supervisor'
}

export type HistoryEntry = {
  __typename?: 'HistoryEntry';
  at: Scalars['NaiveDate']['output'];
  state: ContractState;
};

export type Holiday = {
  __typename?: 'Holiday';
  date: Scalars['NaiveDate']['output'];
  key: Scalars['String']['output'];
  kind: HolidayKind;
  name: Scalars['String']['output'];
};

export enum HolidayKind {
  Bavaria = 'BAVARIA',
  Local = 'LOCAL',
  National = 'NATIONAL',
  Special = 'SPECIAL'
}

export type InboxBankDetails = {
  __typename?: 'InboxBankDetails';
  accountHolder?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  iban: Scalars['String']['output'];
};

export type InboxBooking = {
  __typename?: 'InboxBooking';
  assistedIntegration?: Maybe<Scalars['Boolean']['output']>;
  from?: Maybe<Scalars['NaiveDate']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  migration?: Maybe<Scalars['Boolean']['output']>;
  nurseryChild?: Maybe<Scalars['Boolean']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  schoolChild?: Maybe<Scalars['Boolean']['output']>;
  times: InboxBookingTimes;
  to?: Maybe<Scalars['NaiveDate']['output']>;
};

export type InboxBookingDay = {
  __typename?: 'InboxBookingDay';
  am?: Maybe<TimeRange>;
  lunch: Scalars['Boolean']['output'];
  pm?: Maybe<TimeRange>;
};

export type InboxBookingTimes = {
  __typename?: 'InboxBookingTimes';
  comments?: Maybe<Scalars['String']['output']>;
  fr: InboxBookingDay;
  mo: InboxBookingDay;
  sa: InboxBookingDay;
  su: InboxBookingDay;
  th: InboxBookingDay;
  tu: InboxBookingDay;
  we: InboxBookingDay;
};

export type InboxChild = {
  __typename?: 'InboxChild';
  address: SimpleAddress;
  bankDetails?: Maybe<InboxBankDetails>;
  birth: Birth;
  bookings: Array<InboxBooking>;
  /**
   * Get the connected [`Child`](Child), if this inbox entry is already linked.
   *
   * Requires "view" rights to the `child` resource.
   */
  connectedChild?: Maybe<Child>;
  contract: InboxContract;
  custodians: Array<InboxCustodian>;
  disability?: Maybe<Disability>;
  externalId: Scalars['String']['output'];
  id: Scalars['LongEntityId']['output'];
  /**
   * Get an identical [`Child`](Child) (if such exists). An identical child is defined as a child
   * which has the same first name, last name and birth date. This function returns that child,
   * if and only if it exists uniquely, otherwise `None`.
   *
   * Requires "view" rights to the `child` resource.
   */
  identicalChild?: Maybe<Child>;
  /** The `Child`s id, if one is connected. */
  internalId?: Maybe<Scalars['ObjectId']['output']>;
  person: InboxPerson;
  portal: Portal;
  /** The actual portal instance (if there are multiple), for example the Little Bird subdomain. */
  portalInstance?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  siblings: Array<InboxSibling>;
  /**
   * Get similar [`Children`](Child). For now, this function simply returns all children
   * who share the same last name. Better similarity measures are being designed.
   *
   * Requires "view" rights to the `child` resource.
   */
  similiarChildren: Array<Child>;
  status: InboxChildStatus;
  vaccination?: Maybe<InboxVaccination>;
};

export type InboxChildList = {
  __typename?: 'InboxChildList';
  items: Array<InboxChild>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export enum InboxChildStatus {
  Connected = 'CONNECTED',
  Identical = 'IDENTICAL',
  New = 'NEW',
  NewContract = 'NEW_CONTRACT',
  Rejected = 'REJECTED',
  Similar = 'SIMILAR'
}

export type InboxContract = {
  __typename?: 'InboxContract';
  endOfContract?: Maybe<Scalars['NaiveDate']['output']>;
  registrationDate: Scalars['NaiveDate']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  startOfContract?: Maybe<Scalars['NaiveDate']['output']>;
};

export type InboxCustodian = {
  __typename?: 'InboxCustodian';
  address: SimpleAddress;
  /** "personensorgeberechtigt" */
  allowedToCare: Scalars['Boolean']['output'];
  /** "alleinerziehend" */
  alone: Scalars['Boolean']['output'];
  /** "alleinsorgeberechtigt" */
  aloneCare: Scalars['Boolean']['output'];
  birth: Birth;
  contact: Contact;
  employer?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<MaritalStatus>;
  person: InboxPerson;
  /** "Post" */
  post: Scalars['Boolean']['output'];
  profession?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Relation>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type InboxPerson = {
  __typename?: 'InboxPerson';
  citizenships?: Maybe<Array<Scalars['String']['output']>>;
  denomination?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  languages?: Maybe<Array<Scalars['String']['output']>>;
  lastname: Scalars['String']['output'];
  middlename?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InboxSibling = {
  __typename?: 'InboxSibling';
  birthdate?: Maybe<Scalars['NaiveDate']['output']>;
  firstname: Scalars['String']['output'];
  institution?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
};

export type InboxVaccination = {
  __typename?: 'InboxVaccination';
  earlyDiagnosticsCertified?: Maybe<Scalars['Boolean']['output']>;
  vaccinationCertified?: Maybe<Scalars['Boolean']['output']>;
};

export type Institution = {
  __typename?: 'Institution';
  created: Modification;
  customer?: Maybe<Customer>;
  id: Scalars['LongEntityId']['output'];
  iid?: Maybe<Scalars['ObjectId']['output']>;
  modified?: Maybe<Modification>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
};

/**
 * InstitutionFilter is used when filtering from the perspective of a institution using no filter, from the perspective
 * of an admin, a customer or an organization filtering for a specific institution
 */
export type InstitutionFilter = {
  customer: Scalars['ObjectId']['input'];
  institution: Scalars['ObjectId']['input'];
  organization: Scalars['ObjectId']['input'];
};

export type InstitutionLevel = {
  cid: Scalars['Cid']['input'];
  iid: Scalars['Iid']['input'];
  oid: Scalars['Oid']['input'];
};

export type InstitutionSection = {
  __typename?: 'InstitutionSection';
  contactPerson?: Maybe<ContactPerson>;
  costCenter?: Maybe<Scalars['String']['output']>;
  created: Modification;
  hexColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  institutionDetailsId: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  name: Scalars['String']['output'];
  shortname?: Maybe<Scalars['String']['output']>;
  type: InstitutionType;
};

export type InstitutionStatisticalDetails = {
  __typename?: 'InstitutionStatisticalDetails';
  einrNr: Scalars['String']['output'];
  einrichtung: Scalars['String']['output'];
  kreis: Scalars['String']['output'];
  name1?: Maybe<Scalars['String']['output']>;
  name2?: Maybe<Scalars['String']['output']>;
  name3?: Maybe<Scalars['String']['output']>;
  ort?: Maybe<Scalars['String']['output']>;
  ortsteil?: Maybe<Scalars['String']['output']>;
  plz?: Maybe<Scalars['String']['output']>;
  strasse?: Maybe<Scalars['String']['output']>;
};

export type InstitutionStatisticalDetailsFilter = {
  einrNr?: InputMaybe<Scalars['String']['input']>;
};

export enum InstitutionType {
  ErweiterteMiniKita = 'ERWEITERTE_MINI_KITA',
  HausFuerKinder = 'HAUS_FUER_KINDER',
  Hort = 'HORT',
  Kindergarten = 'KINDERGARTEN',
  Kinderkrippe = 'KINDERKRIPPE',
  KooperativeGanztagesbetreuung = 'KOOPERATIVE_GANZTAGESBETREUUNG',
  MiniKita = 'MINI_KITA',
  Mittagsbetreuung = 'MITTAGSBETREUUNG',
  NetzFuerKinder = 'NETZ_FUER_KINDER',
  Vorschulkindergarten = 'VORSCHULKINDERGARTEN'
}

export enum IntegrativePlace {
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO',
  TwoPointThree = 'TWO_POINT_THREE'
}

export enum Interruption {
  /** "Elternzeit" */
  I2 = 'I2',
  /** "Sabbatjahr" */
  I3 = 'I3',
  /** "Sonderurlaub" */
  I4 = 'I4',
  /** "Freistellungsphase Altersteilzeit" */
  I5 = 'I5'
}

export enum KibigQualification {
  Assistenzkraft = 'ASSISTENZKRAFT',
  Ergaenzungskraft = 'ERGAENZUNGSKRAFT',
  Fachkraft = 'FACHKRAFT',
  HauswirtschaftlichesPersonal = 'HAUSWIRTSCHAFTLICHES_PERSONAL',
  KeineBelegung = 'KEINE_BELEGUNG',
  PaedagogischesPersonal = 'PAEDAGOGISCHES_PERSONAL',
  PraktikantImSej = 'PRAKTIKANT_IM_SEJ',
  /** @deprecated only used until June 2023 */
  Schwerpunktkraft = 'SCHWERPUNKTKRAFT',
  /** only to be used >= July 2023 */
  Sprachfachkraft = 'SPRACHFACHKRAFT',
  Tagespflegeperson = 'TAGESPFLEGEPERSON',
  Verwaltungsfachkraft = 'VERWALTUNGSFACHKRAFT',
  Zusatzkraft = 'ZUSATZKRAFT'
}

export type ListFilter = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type MainDebtor = {
  __typename?: 'MainDebtor';
  /**
   * Get the associated [`Contract`] object.
   *
   * Requires rights to the `contract` resource.
   */
  contract?: Maybe<Contract>;
  contractId: Scalars['StrictEntityId']['output'];
  created: Modification;
  custodianChildId: Scalars['StrictEntityId']['output'];
  /**
   * Get the associated [custody](`CustodianChild`) object.
   *
   * Requires rights to the `child` resource.
   */
  custody?: Maybe<CustodianChild>;
  endDate?: Maybe<Scalars['NaiveDate']['output']>;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  paymentMethod: PaymentMethod;
  startDate: Scalars['NaiveDate']['output'];
};

export type MainDebtorList = {
  __typename?: 'MainDebtorList';
  items: Array<MainDebtor>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ManuallySet = {
  __typename?: 'ManuallySet';
  days: Scalars['Int']['output'];
};

export type ManuallySetInput = {
  days: Scalars['Int']['input'];
};

export enum MaritalStatus {
  /** "getrennt lebend" */
  Gl = 'GL',
  /** "geschieden" */
  Gs = 'GS',
  /** "ledig" */
  Ld = 'LD',
  /** "eingetragene Lebenspartnerschaft" */
  Lp = 'LP',
  /** "nicht verheiratet" */
  Nv = 'NV',
  /** "verheiratet" */
  Vh = 'VH',
  /** "verwitwet" */
  Vw = 'VW',
  /** "wiederverheiratet / geschieden" */
  Wg = 'WG',
  /** "wiederverheiratet / verwitwet" */
  Ww = 'WW'
}

export type MemberId = {
  __typename?: 'MemberId';
  cid: Scalars['ObjectId']['output'];
  iid: Scalars['ObjectId']['output'];
  oid: Scalars['ObjectId']['output'];
};

export type Modification = {
  __typename?: 'Modification';
  at: Scalars['DateTime']['output'];
};

export type MonthlyBooking = {
  __typename?: 'MonthlyBooking';
  allocation: Allocation;
  assistedIntegration: Scalars['Boolean']['output'];
  bookingTime: BookingTime;
  communeKey: Scalars['String']['output'];
  districtSubsidy: Scalars['Boolean']['output'];
  isSchoolChild: Scalars['Boolean']['output'];
  parentalFeeExemption?: Maybe<Scalars['Boolean']['output']>;
  parentalFeeSubsidy?: Maybe<Scalars['Boolean']['output']>;
  subsidyState: ChildSubsidyState;
  subsidyStateWithoutAssistedIntegration: ChildSubsidyState;
  u3: Scalars['Boolean']['output'];
};

export type MonthlyBookingInput = {
  allocation: Allocation;
  assistedIntegration: Scalars['Boolean']['input'];
  bookingTime: BookingTime;
  communeKey: Scalars['String']['input'];
  districtSubsidy: Scalars['Boolean']['input'];
  isSchoolChild: Scalars['Boolean']['input'];
  parentalFeeExemption?: InputMaybe<Scalars['Boolean']['input']>;
  parentalFeeSubsidy?: InputMaybe<Scalars['Boolean']['input']>;
  subsidyState: ChildSubsidyState;
  subsidyStateWithoutAssistedIntegration: ChildSubsidyState;
  u3: Scalars['Boolean']['input'];
};

export type MonthlyBookings = {
  __typename?: 'MonthlyBookings';
  april?: Maybe<MonthlyBooking>;
  august?: Maybe<MonthlyBooking>;
  december?: Maybe<MonthlyBooking>;
  february?: Maybe<MonthlyBooking>;
  january?: Maybe<MonthlyBooking>;
  july?: Maybe<MonthlyBooking>;
  june?: Maybe<MonthlyBooking>;
  march?: Maybe<MonthlyBooking>;
  may?: Maybe<MonthlyBooking>;
  november?: Maybe<MonthlyBooking>;
  october?: Maybe<MonthlyBooking>;
  september?: Maybe<MonthlyBooking>;
};

export type MonthlyBookingsInput = {
  april?: InputMaybe<MonthlyBookingInput>;
  august?: InputMaybe<MonthlyBookingInput>;
  december?: InputMaybe<MonthlyBookingInput>;
  february?: InputMaybe<MonthlyBookingInput>;
  january?: InputMaybe<MonthlyBookingInput>;
  july?: InputMaybe<MonthlyBookingInput>;
  june?: InputMaybe<MonthlyBookingInput>;
  march?: InputMaybe<MonthlyBookingInput>;
  may?: InputMaybe<MonthlyBookingInput>;
  november?: InputMaybe<MonthlyBookingInput>;
  october?: InputMaybe<MonthlyBookingInput>;
  september?: InputMaybe<MonthlyBookingInput>;
};

export type MonthlyRecord = {
  __typename?: 'MonthlyRecord';
  creditableWorkingHours: Scalars['Float']['output'];
  position?: Maybe<Position>;
  qualification: KibigQualification;
  status: EmployeeSubsidyStatus;
};

export type MonthlyRecordInput = {
  creditableWorkingHours: Scalars['Float']['input'];
  position?: InputMaybe<Position>;
  qualification: KibigQualification;
  status: EmployeeSubsidyStatus;
};

export type MonthlyRecords = {
  __typename?: 'MonthlyRecords';
  april?: Maybe<MonthlyRecord>;
  august?: Maybe<MonthlyRecord>;
  december?: Maybe<MonthlyRecord>;
  february?: Maybe<MonthlyRecord>;
  january?: Maybe<MonthlyRecord>;
  july?: Maybe<MonthlyRecord>;
  june?: Maybe<MonthlyRecord>;
  march?: Maybe<MonthlyRecord>;
  may?: Maybe<MonthlyRecord>;
  november?: Maybe<MonthlyRecord>;
  october?: Maybe<MonthlyRecord>;
  september?: Maybe<MonthlyRecord>;
};

export type MonthlyRecordsInput = {
  april?: InputMaybe<MonthlyRecordInput>;
  august?: InputMaybe<MonthlyRecordInput>;
  december?: InputMaybe<MonthlyRecordInput>;
  february?: InputMaybe<MonthlyRecordInput>;
  january?: InputMaybe<MonthlyRecordInput>;
  july?: InputMaybe<MonthlyRecordInput>;
  june?: InputMaybe<MonthlyRecordInput>;
  march?: InputMaybe<MonthlyRecordInput>;
  may?: InputMaybe<MonthlyRecordInput>;
  november?: InputMaybe<MonthlyRecordInput>;
  october?: InputMaybe<MonthlyRecordInput>;
  september?: InputMaybe<MonthlyRecordInput>;
};

/**
 * The number of months to take into account when grouping monthly fee types into accounting groups.
 *
 * Used for "monatliche Erhebung: Anzahl Monate".
 */
export enum Months {
  /** "September bis Juli" */
  Eleven = 'ELEVEN',
  /** "September bis August" */
  Twelve = 'TWELVE'
}

export type Movement = {
  __typename?: 'Movement';
  entry: Scalars['NaiveDate']['output'];
  exit?: Maybe<Scalars['NaiveDate']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type MovementInput = {
  entry: Scalars['NaiveDate']['input'];
  exit?: InputMaybe<Scalars['NaiveDate']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRoot = {
  __typename?: 'MutationRoot';
  /**
   * Create the fees in the database.
   *
   * Requires the `fee:create` right.
   *
   * If no `receipt_date` is provided, the system date is used.
   *
   * # Assumptions
   * - The accounting run is within a single institution.
   * - Fee values are already calculated fully.
   * - All the debtor portions are set up properly.
   * - `fee_ticket_id` points to a fee ticket of the given year_month, if it exists. Otherwise it is empty.
   */
  accountingRunFromFees: AccountingRun;
  /**
   * Connect an [`InboxChild`](InboxChild) to a [`Child`](Child).
   *
   * Requires the `inbox_child:update` right.
   */
  connectInboxChild: InboxChild;
  /** Requires the `fee:create` right. */
  createAccountingGroup: AccountingGroup;
  /** Requires the `address:create` right. */
  createAddress: Address;
  /** Requires the `address:update` and `category:update` rights. */
  createAddressCategoryAssignment: AddressCategory;
  /** Requires the `analysis:create` right. */
  createAnalysis: Analysis;
  /** Requires the `appointment:create` right. */
  createAppointment: Appointment;
  /** Requires the `appointment:update` and `child:update` rights. */
  createAppointmentChildAssignment: AppointmentChild;
  /** Requires the `appointment:update` and `employee:update` rights. */
  createAppointmentEmployeeAssignment: AppointmentEmployee;
  /** Requires the `booking:create` right. */
  createBooking: Booking;
  /** Requires the `category:create` right. */
  createCategory: Category;
  /** Requires the `characteristic:create` right. */
  createCharacteristic: Characteristic;
  /** Requires the `child:create` right. */
  createChild: Child;
  /** Requires the `child:update` and `address:update` rights. */
  createChildAddressAssignment: ChildAddress;
  /** Requires the `child:update` and `characteristic:update` rights. */
  createChildCharacteristicAssignment: ChildCharacteristic;
  /** Requires the `child:update` and `characteristic:update` rights. */
  createChildrenCharacteristicsAssignments: Array<ChildCharacteristic>;
  /** Requires the `commune:create` right. */
  createCommune: Commune;
  /** Requires the `contract:create` right. */
  createContract: Contract;
  /** Requires the `contract:update` right. */
  createContractFeeTypeAssignment: ContractFeeType;
  /** Requires the `child:create` right. */
  createCustodian: Custodian;
  /** Requires the `category:update` right. */
  createCustodianCategoryAssignment: CustodianCategory;
  /** Requires the `child:update` right. */
  createCustodianChildAssignment: CustodianChild;
  /** Requires the `customer:create` right. */
  createCustomer: ProjectCustomer;
  /** Requires the `contract:create` right. */
  createDebtorAgreement: DebtorAgreement;
  /** Requires the `contract:update` and `fee:update` rights. */
  createDebtorAgreementContractFeeTypeAssignment: DebtorAgreementContractFeeType;
  /**
   * Create a debtor assignment.
   *
   * Requires the `contract:update` right.
   *
   * This is what generally is referred to as "Debtor", despite it being an assignment.
   *
   * The assignment can either be between a [`Contract`] and
   * - an [address](Address)
   * - a [custody](CustodianChild)
   * - a [youth welfare office](YouthWelfareOffice)
   */
  createDebtorAssignment: Debtor;
  /** Requires the `employee:create` right. */
  createEmployee: Employee;
  /** Requires the `employee:update` and `category:update` rights. */
  createEmployeeCategoryAssignment: EmployeeCategory;
  /** Requires the `employee:update` and `group:update` rights. */
  createEmployeeGroupAssignment: EmployeeGroup;
  /** Requires the `employee:update` and `qualification:update` rights. */
  createEmployeeQualificationAssignment: EmployeeQualification;
  /** Requires the `employment:create` right. */
  createEmployment: Employment;
  /** Requires the `fee:create` right. */
  createFee: Fee;
  /** Requires the `fee:create` right. */
  createFeeDraft: FeeDraft;
  /** Requires the `fee:update` right. */
  createFeeDraftFeeTypeAssignment: FeeDraftFeeType;
  /** Requires the `fee:create` right. */
  createFeeTicket: FeeTicket;
  /** Requires the `fee:create` right. */
  createFeeType: FeeType;
  /**
   * Create multiple fees.
   *
   * Requires the `fee:create` right.
   *
   * Errors on creation are ignored and only the successfully created fees are returned.
   */
  createFees: Array<Fee>;
  /** Requires the `food_type:create` right. */
  createFoodType: FoodType;
  /** Requires the `group:create` right. */
  createGroup: Group;
  /** Requires the `group:update` and `contract:update` rights. */
  createGroupContractAssignment: GroupContract;
  /** Requires the `institution:create` right. */
  createInstitution: ProjectInstitution;
  /** Requires the `institution:create` right. */
  createInstitutionSection: InstitutionSection;
  /**
   * Create a main debtor assignment.
   *
   * Requires the `contract:update` right.
   *
   * The assignment is between an `child_custodian` and `contract`.
   */
  createMainDebtorAssignment: MainDebtor;
  /** Requires the `organization:create` right. */
  createOrganization: ProjectOrganization;
  /** Requires the `organization_unit:create` right. */
  createOrganizationUnit: ProjectOrganizationUnit;
  /** Requires the `qualification:create` right. */
  createQualification: Qualification;
  /**
   * Create a receipt in the migration.
   *
   * Requires the `receipt_view` right.
   */
  createReceipt: Receipt;
  /**
   * Create multiple receipts in the migration.
   *
   * Requires the `receipt_view` right.
   *
   * Errors on creation are ignored and only the successfully created receipts are returned.
   */
  createReceipts: Array<Receipt>;
  /** Requires the `role:create` right. */
  createRole: Role;
  /** Requires the `school:create` right. */
  createSchool: School;
  /** Requires the `fee:create` right. */
  createSepaMandate: SepaMandate;
  /** Requires the `service_type:create` right. */
  createServiceType: ServiceType;
  /**
   * Create a sibling assignment between children.
   *
   * Requires the `child:update` right.
   *
   * When creating a sibling assignment, the order of the children is not relevant.
   * The assignment is
   * 1. not reflexive, i.e. "x is not sibling of itself",
   * 2. symmetric, i.e. "x is sibling of y <=> y is sibling of x",
   * 3. almost transitive, i.e "x is sibling of y & y is sibling of z & x != z => x is sibling of z"
   */
  createSiblingAssignment: Array<Child>;
  createTableFilter: TableFilter;
  createTablePreset: TablePreset;
  /** Requires the `user:create` right. */
  createUser: User;
  /** Requires the `youth_welfare_office:create` right. */
  createYouthWelfareOffice: YouthWelfareOffice;
  /** Requires the `fee:update` right. */
  deactivateFeeTypes: Scalars['Int']['output'];
  /**
   * Disconnect an [`InboxChild`](InboxChild) from its associated [`Child`](Child).
   *
   * Requires the `inbox_child:update` right.
   */
  disconnectInboxChild: InboxChild;
  editConfigMeta: Scalars['Boolean']['output'];
  /** Requires the `baykibig_export` right */
  exportToKibig: Scalars['String']['output'];
  /** Requires the `address:create` right. */
  linkAddresses: Scalars['Int']['output'];
  /** Requires the `category:create` right. */
  linkCategories: Scalars['Int']['output'];
  /** Requires the `commune:create` right. */
  linkCommunes: Scalars['Int']['output'];
  /** Requires the `food_type:create` right. */
  linkFoodTypes: Scalars['Int']['output'];
  /** Requires the `qualification:create` right. */
  linkQualifications: Scalars['Int']['output'];
  /** Requires the `school:create` right. */
  linkSchools: Scalars['Int']['output'];
  /** Requires the `service_type:create` right. */
  linkServiceTypes: Scalars['Int']['output'];
  /** Requires the `youth_welfare_office:create` right. */
  linkYouthWelfareOffices: Scalars['Int']['output'];
  /** Requires the `fee:update` right. */
  reactivateFeeTypes: Scalars['Int']['output'];
  rejectInboxChildren: Array<InboxChild>;
  /** Requires the `fee:delete` right. */
  removeAccountingGroups: Scalars['Int']['output'];
  /** Requires the `address:update` and `category:update` rights. */
  removeAddressCategoryAssignments: Scalars['Int']['output'];
  /** Requires the `address:delete` right. */
  removeAddresses: Scalars['Int']['output'];
  /** Requires the `analysis:delete` right. */
  removeAnalyses: Scalars['Int']['output'];
  /** Requires the `appointment:update` and `child:update` rights. */
  removeAppointmentChildAssignments: Scalars['Int']['output'];
  /** Requires the `appointment:update` and `employee:update` rights. */
  removeAppointmentEmployeeAssignments: Scalars['Int']['output'];
  /** Requires the `appointment:delete` right. */
  removeAppointments: Scalars['Int']['output'];
  /** Requires the `booking:delete` right. */
  removeBookings: Scalars['Int']['output'];
  /** Requires the `category:delete` right. */
  removeCategories: Scalars['Int']['output'];
  /** Requires the `characteristic:delete` right. */
  removeCharacteristics: Scalars['Int']['output'];
  /** Requires the `child:update` and `address:update` rights. */
  removeChildAddressAssignments: Scalars['Int']['output'];
  /** Requires the `child:update` and `characteristic:update` rights. */
  removeChildCharacteristicAssignments: Scalars['Int']['output'];
  /** Requires the `child:delete` right. */
  removeChildren: Scalars['Int']['output'];
  /** Requires the `child:update` and `characteristic:update` rights. */
  removeChildrenCharacteristicsAssignments: Scalars['Int']['output'];
  /** Requires the `commune:delete` right. */
  removeCommunes: Scalars['Int']['output'];
  /** Requires the `contract:update` right. */
  removeContractFeeTypeAssignments: Scalars['Int']['output'];
  /** Requires the `contract:delete` right. */
  removeContracts: Scalars['Int']['output'];
  /** Requires the `category:update` right. */
  removeCustodianCategoryAssignments: Scalars['Int']['output'];
  /** Requires the `child:update` right. */
  removeCustodianChildAssignments: Scalars['Int']['output'];
  /** Requires the `child:delete` right. */
  removeCustodians: Scalars['Int']['output'];
  /** Requires the `customer:delete` right. */
  removeCustomers: Scalars['Int']['output'];
  /** Requires the `contract:update` and `fee:update` rights. */
  removeDebtorAgreementContractFeeTypeAssignments: Scalars['Int']['output'];
  /** Requires the `contract:delete` right. */
  removeDebtorAgreements: Scalars['Int']['output'];
  /** Requires the `contract:update` right. */
  removeDebtorAssignments: Scalars['Int']['output'];
  /** Requires the `employee:update` and `category:update` rights. */
  removeEmployeeCategoryAssignments: Scalars['Int']['output'];
  /** Requires the `employee:update` and `group:update` rights. */
  removeEmployeeGroupAssignments: Scalars['Int']['output'];
  /** Requires the `employee:update` and `qualification:update` rights. */
  removeEmployeeQualificationAssignments: Scalars['Int']['output'];
  /** Requires the `employee:delete` right. */
  removeEmployees: Scalars['Int']['output'];
  /** Requires the `employment:delete` right. */
  removeEmployments: Scalars['Int']['output'];
  /** Requires the `fee:update` right. */
  removeFeeDraftFeeTypeAssignments: Scalars['Int']['output'];
  /** Requires the `fee:delete` right. */
  removeFeeDrafts: Scalars['Int']['output'];
  /** Requires the `fee:delete` right. */
  removeFeeTypes: Scalars['Int']['output'];
  /** Requires the `food_type:delete` right. */
  removeFoodTypes: Scalars['Int']['output'];
  /** Requires the `group:update` and `contract:update` rights. */
  removeGroupContractAssignments: Scalars['Int']['output'];
  /** Requires the `group:delete` right. */
  removeGroups: Scalars['Int']['output'];
  /** Requires the `institution:delete` right. */
  removeInstitutionSections: Scalars['Int']['output'];
  /** Requires the `institution:delete` right. */
  removeInstitutions: Scalars['Int']['output'];
  /** Requires the `contract:update` right. */
  removeMainDebtorAssignments: Scalars['Int']['output'];
  /** Requires the `organization_unit:delete` right. */
  removeOrganizationUnits: Scalars['Int']['output'];
  /** Requires the `organization:delete` right. */
  removeOrganizations: Scalars['Int']['output'];
  /** Requires the `qualification:delete` right. */
  removeQualifications: Scalars['Int']['output'];
  /** Requires the `role:delete` right. */
  removeRoles: Scalars['Int']['output'];
  /** Requires the `school:delete` right. */
  removeSchools: Scalars['Int']['output'];
  /** Requires the `service_type:delete` right. */
  removeServiceTypes: Scalars['Int']['output'];
  /**
   * Remove sibling assignments between children.
   *
   * Requires the `child:update` right.
   *
   * Deleting an assignment is automatically mirrored.
   * I.e. when deleting relation from "a to b", "b to a" is deleted automatically.
   */
  removeSiblingAssignments: Scalars['Int']['output'];
  removeTableFilters: Scalars['Int']['output'];
  removeTablePresets: Scalars['Int']['output'];
  /** Requires the `user:delete` right. */
  removeUsers: Scalars['Int']['output'];
  /** Requires the `youth_welfare_office:delete` right. */
  removeYouthWelfareOffices: Scalars['Int']['output'];
  /**
   * Reset a users password.
   *
   * The flag `temporary` evaluates to `true` if it is not provided.
   * A temporary password must be updated by the user after login.
   *
   * Requires the `user:update` right
   */
  resetUserPassword: User;
  /**
   * Assumes that all dates are distinct.
   *
   * Requires the `booking:update` right.
   */
  setBookingDays: BookingDayResult;
  /** Requires the `fee:update` right. */
  setDefaultAccountingGroup: Scalars['Int']['output'];
  setDefaultFilter: Scalars['Boolean']['output'];
  setDefaultPreset: Scalars['Boolean']['output'];
  setNote: Scalars['String']['output'];
  /**
   * Sets the [PresenceKind] for all children at the specified date.
   *
   * Requires the `child:update` right.
   *
   * Returns the number of changed entries.
   */
  setPresence: Scalars['Int']['output'];
  /**
   * Sets the [PresenceComplete] for specified month.
   *
   * Requires the `child:update` right.
   */
  setPresenceMonthComplete: Scalars['Boolean']['output'];
  /** Requires the `fee:update` right. */
  setStandardFeeDraft: Scalars['Int']['output'];
  unrejectInboxChildren: Array<InboxChild>;
  unsetDefaultFilter: Scalars['Boolean']['output'];
  unsetDefaultPreset: Scalars['Boolean']['output'];
  /** Requires the `fee:update` right. */
  updateAccountingGroup: AccountingGroup;
  /** Requires the `address:update` right. */
  updateAddress: Address;
  /** Requires the `analysis:update` right. */
  updateAnalysis: Analysis;
  /** Requires the `appointment:update` right. */
  updateAppointment: Appointment;
  /** Requires the `booking:update` right. */
  updateBooking: Booking;
  /** Requires the `category:update` right. */
  updateCategory: Category;
  /** Requires the `characteristic:update` right. */
  updateCharacteristic: Characteristic;
  /** Requires the `child:update` right. */
  updateChild: Child;
  /** Requires the `child:update` right. */
  updateChildrenState: Scalars['Int']['output'];
  /** Requires the `commune:update` right. */
  updateCommune: Commune;
  /** Requires the `contract:update` right. */
  updateContract: Contract;
  /** Requires the `contract:update` right. */
  updateContractFeeTypeAssignment: ContractFeeType;
  /** Requires the `child:update` right. */
  updateCustodian: Custodian;
  /** Requires the `child:update` right. */
  updateCustodianChildAssignment: CustodianChild;
  /** Requires the `customer:update` right. */
  updateCustomer: ProjectCustomer;
  /** Requires the `contract:update` right. */
  updateDebtorAgreement: DebtorAgreement;
  /** Requires the `contract:update` and `fee:update` rights. */
  updateDebtorAgreementContractFeeTypeAssignment: DebtorAgreementContractFeeType;
  /** Requires the `contract:update` right. */
  updateDebtorAssignment: Debtor;
  /** Requires the `employee:update` right. */
  updateEmployee: Employee;
  /** Requires the `employee:update` and `group:update` rights. */
  updateEmployeeGroupAssignment: EmployeeGroup;
  /** Requires the `employee:update` and `qualification:update` rights. */
  updateEmployeeQualificationAssignment: EmployeeQualification;
  /** Requires the `employment:update` right. */
  updateEmployment: Employment;
  /** Requires the `fee:update` right. */
  updateFee: Fee;
  /** Requires the `fee:update` right. */
  updateFeeDraft: FeeDraft;
  /** Requires the `fee:update` right. */
  updateFeeDraftFeeTypeAssignment: FeeDraftFeeType;
  /** Requires the `fee:update` right. */
  updateFeeTicket: FeeTicket;
  /** Requires the `fee:update` right. */
  updateFeeType: FeeType;
  /** Requires the `food_type:update` right. */
  updateFoodType: FoodType;
  /** Requires the `group:update` right. */
  updateGroup: Group;
  /** Requires the `group:update` and `contract:update` rights. */
  updateGroupContractAssignment: GroupContract;
  /** Requires the `institution:update` right. */
  updateInstitution: ProjectInstitution;
  /** Requires the `institution:update` right. */
  updateInstitutionSection: InstitutionSection;
  /** Requires the `contract:update` right. */
  updateMainDebtorAssignment: MainDebtor;
  /** Requires the `organization:update` right. */
  updateOrganization: ProjectOrganization;
  /** Requires the `organization_unit:update` right. */
  updateOrganizationUnit: ProjectOrganizationUnit;
  /** Requires the `qualification:update` right. */
  updateQualification: Qualification;
  /** Requires the `role:update` right. */
  updateRole: Role;
  /** Requires the `school:update` right. */
  updateSchool: School;
  /** Requires the `service_type:update` right. */
  updateServiceType: ServiceType;
  updateTableFilter: TableFilter;
  updateTablePreset: TablePreset;
  /** Requires the `user:update` right. */
  updateUser: User;
  /** Requires the `user_access_change` right. */
  updateUserAccess: User;
  /** Requires the `youth_welfare_office:update` right. */
  updateYouthWelfareOffice: YouthWelfareOffice;
  writeConfig: Scalars['Boolean']['output'];
};


export type MutationRootAccountingRunFromFeesArgs = {
  context: InstitutionFilter;
  input: CreateAccountingRunInput;
};


export type MutationRootConnectInboxChildArgs = {
  childId: Scalars['ObjectId']['input'];
  id: Scalars['StrictEntityId']['input'];
};


export type MutationRootCreateAccountingGroupArgs = {
  context: InstitutionFilter;
  input: CreateAccountingGroupInput;
};


export type MutationRootCreateAddressArgs = {
  context: InstitutionFilter;
  input: CreateAddressInput;
};


export type MutationRootCreateAddressCategoryAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateAddressCategoryInput;
};


export type MutationRootCreateAnalysisArgs = {
  context: InstitutionFilter;
  input: CreateAnalysisInput;
};


export type MutationRootCreateAppointmentArgs = {
  context: InstitutionFilter;
  input: CreateAppointmentInput;
};


export type MutationRootCreateAppointmentChildAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateAppointmentChildInput;
};


export type MutationRootCreateAppointmentEmployeeAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateAppointmentEmployeeInput;
};


export type MutationRootCreateBookingArgs = {
  context: InstitutionFilter;
  input: CreateBookingInput;
};


export type MutationRootCreateCategoryArgs = {
  context: InstitutionFilter;
  input: CreateCategoryInput;
};


export type MutationRootCreateCharacteristicArgs = {
  context: InstitutionFilter;
  input: CreateCharacteristicInput;
};


export type MutationRootCreateChildArgs = {
  context: InstitutionFilter;
  input: CreateChildInput;
};


export type MutationRootCreateChildAddressAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateChildAddressInput;
};


export type MutationRootCreateChildCharacteristicAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateChildCharacteristicInput;
};


export type MutationRootCreateChildrenCharacteristicsAssignmentsArgs = {
  context: InstitutionFilter;
  input: ChildCharacteristicBulkInput;
};


export type MutationRootCreateCommuneArgs = {
  context: InstitutionFilter;
  input: CreateCommuneInput;
};


export type MutationRootCreateContractArgs = {
  context: InstitutionFilter;
  input: CreateContractInput;
};


export type MutationRootCreateContractFeeTypeAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateContractFeeTypeInput;
};


export type MutationRootCreateCustodianArgs = {
  context: InstitutionFilter;
  input: CreateCustodianInput;
};


export type MutationRootCreateCustodianCategoryAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateCustodianCategoryInput;
};


export type MutationRootCreateCustodianChildAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateCustodianChildInput;
};


export type MutationRootCreateCustomerArgs = {
  name: Scalars['String']['input'];
};


export type MutationRootCreateDebtorAgreementArgs = {
  context: InstitutionFilter;
  input: CreateDebtorAgreementInput;
};


export type MutationRootCreateDebtorAgreementContractFeeTypeAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateDebtorAgreementContractFeeTypeInput;
};


export type MutationRootCreateDebtorAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateDebtorInput;
};


export type MutationRootCreateEmployeeArgs = {
  context: InstitutionFilter;
  input: CreateEmployeeInput;
};


export type MutationRootCreateEmployeeCategoryAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateEmployeeCategoryInput;
};


export type MutationRootCreateEmployeeGroupAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateEmployeeGroupInput;
};


export type MutationRootCreateEmployeeQualificationAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateEmployeeQualificationInput;
};


export type MutationRootCreateEmploymentArgs = {
  context: InstitutionFilter;
  input: CreateEmploymentInput;
};


export type MutationRootCreateFeeArgs = {
  context: InstitutionFilter;
  input: CreateFeeInput;
};


export type MutationRootCreateFeeDraftArgs = {
  context: InstitutionFilter;
  input: CreateFeeDraftInput;
};


export type MutationRootCreateFeeDraftFeeTypeAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateFeeDraftFeeTypeInput;
};


export type MutationRootCreateFeeTicketArgs = {
  context: InstitutionFilter;
  input: CreateFeeTicketInput;
};


export type MutationRootCreateFeeTypeArgs = {
  context: InstitutionFilter;
  input: CreateFeeTypeInput;
};


export type MutationRootCreateFeesArgs = {
  context: InstitutionFilter;
  input: Array<CreateFeeInput>;
};


export type MutationRootCreateFoodTypeArgs = {
  context: InstitutionFilter;
  input: CreateFoodTypeInput;
};


export type MutationRootCreateGroupArgs = {
  context: InstitutionFilter;
  input: CreateGroupInput;
};


export type MutationRootCreateGroupContractAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateGroupContractInput;
};


export type MutationRootCreateInstitutionArgs = {
  context: OrganizationFilter;
  name: Scalars['String']['input'];
};


export type MutationRootCreateInstitutionSectionArgs = {
  context: InstitutionFilter;
  input: CreateInstitutionSectionInput;
};


export type MutationRootCreateMainDebtorAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateMainDebtorInput;
};


export type MutationRootCreateOrganizationArgs = {
  context: CustomerFilter;
  name: Scalars['String']['input'];
};


export type MutationRootCreateOrganizationUnitArgs = {
  context: ContextFilterInput;
  members: Array<InstitutionFilter>;
  name: Scalars['String']['input'];
};


export type MutationRootCreateQualificationArgs = {
  context: InstitutionFilter;
  input: CreateQualificationInput;
};


export type MutationRootCreateReceiptArgs = {
  context: InstitutionFilter;
  input: CreateReceiptInput;
};


export type MutationRootCreateReceiptsArgs = {
  context: InstitutionFilter;
  input: Array<CreateReceiptInput>;
};


export type MutationRootCreateRoleArgs = {
  context: CustomerFilter;
  input: CreateRoleInput;
};


export type MutationRootCreateSchoolArgs = {
  context: InstitutionFilter;
  input: CreateSchoolInput;
};


export type MutationRootCreateSepaMandateArgs = {
  input: CreateSepaMandateInput;
};


export type MutationRootCreateServiceTypeArgs = {
  context: InstitutionFilter;
  input: CreateServiceTypeInput;
};


export type MutationRootCreateSiblingAssignmentArgs = {
  context: InstitutionFilter;
  input: CreateSiblingAssignmentInput;
};


export type MutationRootCreateTableFilterArgs = {
  columns: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  table: TableFilterTable;
};


export type MutationRootCreateTablePresetArgs = {
  columns: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  table: Table;
};


export type MutationRootCreateUserArgs = {
  access: AccessInput;
  user: CreateUserInput;
};


export type MutationRootCreateYouthWelfareOfficeArgs = {
  context: InstitutionFilter;
  input: CreateYouthWelfareOfficeInput;
};


export type MutationRootDeactivateFeeTypesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootDisconnectInboxChildArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type MutationRootEditConfigMetaArgs = {
  metaContext: ContextFilter;
  values: Scalars['JSONObject']['input'];
};


export type MutationRootExportToKibigArgs = {
  kibigkey: Scalars['String']['input'];
  username: Scalars['String']['input'];
  xml: Scalars['String']['input'];
};


export type MutationRootLinkAddressesArgs = {
  context: Array<InstitutionFilter>;
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootLinkCategoriesArgs = {
  context: Array<InstitutionFilter>;
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootLinkCommunesArgs = {
  context: Array<InstitutionFilter>;
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootLinkFoodTypesArgs = {
  context: Array<InstitutionFilter>;
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootLinkQualificationsArgs = {
  context: Array<InstitutionFilter>;
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootLinkSchoolsArgs = {
  context: Array<InstitutionFilter>;
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootLinkServiceTypesArgs = {
  context: Array<InstitutionFilter>;
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootLinkYouthWelfareOfficesArgs = {
  context: Array<InstitutionFilter>;
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootReactivateFeeTypesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRejectInboxChildrenArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveAccountingGroupsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveAddressCategoryAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveAddressesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveAnalysesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveAppointmentChildAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveAppointmentEmployeeAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveAppointmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveBookingsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveCategoriesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveCharacteristicsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveChildAddressAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveChildCharacteristicAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveChildrenArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveChildrenCharacteristicsAssignmentsArgs = {
  input: ChildCharacteristicBulkInput;
};


export type MutationRootRemoveCommunesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveContractFeeTypeAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveContractsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveCustodianCategoryAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveCustodianChildAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveCustodiansArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveCustomersArgs = {
  ids: Array<StrictCustomerId>;
};


export type MutationRootRemoveDebtorAgreementContractFeeTypeAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveDebtorAgreementsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveDebtorAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveEmployeeCategoryAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveEmployeeGroupAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveEmployeeQualificationAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveEmployeesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveEmploymentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveFeeDraftFeeTypeAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveFeeDraftsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveFeeTypesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveFoodTypesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveGroupContractAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveGroupsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveInstitutionSectionsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveInstitutionsArgs = {
  ids: Array<StrictInstitutionId>;
};


export type MutationRootRemoveMainDebtorAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveOrganizationUnitsArgs = {
  ids: Array<StrictOrganizationUnitId>;
};


export type MutationRootRemoveOrganizationsArgs = {
  ids: Array<StrictOrganizationId>;
};


export type MutationRootRemoveQualificationsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveRolesArgs = {
  ids: Array<Scalars['RoleId']['input']>;
};


export type MutationRootRemoveSchoolsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveServiceTypesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveSiblingAssignmentsArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootRemoveTableFiltersArgs = {
  ids: Array<Scalars['ObjectId']['input']>;
};


export type MutationRootRemoveTablePresetsArgs = {
  ids: Array<Scalars['ObjectId']['input']>;
};


export type MutationRootRemoveUsersArgs = {
  ids: Array<Scalars['LongEntityId']['input']>;
};


export type MutationRootRemoveYouthWelfareOfficesArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootResetUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['UUID']['input'];
};


export type MutationRootSetBookingDaysArgs = {
  childId: Scalars['StrictEntityId']['input'];
  days: BookingDayInput;
};


export type MutationRootSetDefaultAccountingGroupArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type MutationRootSetDefaultFilterArgs = {
  id: Scalars['ObjectId']['input'];
  table: TableFilterTable;
};


export type MutationRootSetDefaultPresetArgs = {
  id: Scalars['ObjectId']['input'];
  table: Table;
};


export type MutationRootSetNoteArgs = {
  note: Scalars['String']['input'];
};


export type MutationRootSetPresenceArgs = {
  childIds: Array<Scalars['StrictEntityId']['input']>;
  date: Scalars['NaiveDate']['input'];
  kind?: InputMaybe<PresenceKind>;
  pickedUp?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRootSetPresenceMonthCompleteArgs = {
  complete: Scalars['Boolean']['input'];
  context: InstitutionFilter;
  date: Scalars['YearMonth']['input'];
};


export type MutationRootSetStandardFeeDraftArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type MutationRootUnrejectInboxChildrenArgs = {
  ids: Array<Scalars['StrictEntityId']['input']>;
};


export type MutationRootUnsetDefaultFilterArgs = {
  table: TableFilterTable;
};


export type MutationRootUnsetDefaultPresetArgs = {
  table: Table;
};


export type MutationRootUpdateAccountingGroupArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateAccountingGroupInput;
};


export type MutationRootUpdateAddressArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateAddressInput;
};


export type MutationRootUpdateAnalysisArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateAnalysisInput;
};


export type MutationRootUpdateAppointmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateAppointmentInput;
};


export type MutationRootUpdateBookingArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateBookingInput;
};


export type MutationRootUpdateCategoryArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateCategoryInput;
};


export type MutationRootUpdateCharacteristicArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateCharacteristicInput;
};


export type MutationRootUpdateChildArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateChildInput;
};


export type MutationRootUpdateChildrenStateArgs = {
  inputs: Array<UpdateChildStateInput>;
};


export type MutationRootUpdateCommuneArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateCommuneInput;
};


export type MutationRootUpdateContractArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateContractInput;
};


export type MutationRootUpdateContractFeeTypeAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateContractFeeTypeInput;
};


export type MutationRootUpdateCustodianArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateCustodianInput;
};


export type MutationRootUpdateCustodianChildAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateCustodianChildInput;
};


export type MutationRootUpdateCustomerArgs = {
  context: CustomerFilter;
  input: UpdateProjectCustomerInput;
};


export type MutationRootUpdateDebtorAgreementArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateDebtorAgreementInput;
};


export type MutationRootUpdateDebtorAgreementContractFeeTypeAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateDebtorAgreementContractFeeTypeInput;
};


export type MutationRootUpdateDebtorAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateDebtorInput;
};


export type MutationRootUpdateEmployeeArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateEmployeeInput;
};


export type MutationRootUpdateEmployeeGroupAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateEmployeeGroupInput;
};


export type MutationRootUpdateEmployeeQualificationAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateEmployeeQualificationInput;
};


export type MutationRootUpdateEmploymentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateEmploymentInput;
};


export type MutationRootUpdateFeeArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateFeeInput;
};


export type MutationRootUpdateFeeDraftArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateFeeDraftInput;
};


export type MutationRootUpdateFeeDraftFeeTypeAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateFeeDraftFeeTypeInput;
};


export type MutationRootUpdateFeeTicketArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateFeeTicketInput;
};


export type MutationRootUpdateFeeTypeArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateFeeTypeInput;
};


export type MutationRootUpdateFoodTypeArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateFoodTypeInput;
};


export type MutationRootUpdateGroupArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateGroupInput;
};


export type MutationRootUpdateGroupContractAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateGroupContractInput;
};


export type MutationRootUpdateInstitutionArgs = {
  context: InstitutionFilter;
  input: UpdateProjectInstitutionInput;
};


export type MutationRootUpdateInstitutionSectionArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateInstitutionSectionInput;
};


export type MutationRootUpdateMainDebtorAssignmentArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateMainDebtorInput;
};


export type MutationRootUpdateOrganizationArgs = {
  context: OrganizationFilter;
  input: UpdateProjectOrganizationInput;
};


export type MutationRootUpdateOrganizationUnitArgs = {
  context: StrictOrganizationUnitId;
  input: UpdateProjectOrganizationUnitInput;
};


export type MutationRootUpdateQualificationArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateQualificationInput;
};


export type MutationRootUpdateRoleArgs = {
  id: Scalars['RoleId']['input'];
  input: UpdateRoleInput;
};


export type MutationRootUpdateSchoolArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateSchoolInput;
};


export type MutationRootUpdateServiceTypeArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateServiceTypeInput;
};


export type MutationRootUpdateTableFilterArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ObjectId']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRootUpdateTablePresetArgs = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ObjectId']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRootUpdateUserArgs = {
  input: UpdateUserInput;
  userId: Scalars['UUID']['input'];
};


export type MutationRootUpdateUserAccessArgs = {
  input: UpdateUserAccessInput;
  userId: Scalars['UUID']['input'];
};


export type MutationRootUpdateYouthWelfareOfficeArgs = {
  id: Scalars['StrictEntityId']['input'];
  input: UpdateYouthWelfareOfficeInput;
};


export type MutationRootWriteConfigArgs = {
  context: ContextFilter;
  values: Scalars['JSONObject']['input'];
};

export type Open = {
  __typename?: 'Open';
  /** This field is necessary, because GraphQL does not allow for unit types to be part of a union. */
  ignoreThis: Scalars['Int']['output'];
};

export type OpenInput = {
  /** This field is necessary, because GraphQL does not allow for unit types to be part of a union. */
  ignoreThis: Scalars['Int']['input'];
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  integrativePlace?: Maybe<IntegrativePlace>;
  placesNecessity?: Maybe<PlaceNecessity>;
  times?: Maybe<Times>;
};

export enum Operation {
  Create = 'create',
  Delete = 'delete',
  List = 'list',
  Report = 'report',
  Unlock = 'unlock',
  Update = 'update',
  View = 'view'
}

/** The GraphQL version for [`OperationalRole`] with named fields */
export type OperationalPermission = {
  __typename?: 'OperationalPermission';
  operation: Operation;
  resourceType: ResourceType;
};

/** The GraphQL version for [`OperationalRole`] with named fields */
export type OperationalPermissionInput = {
  operation: Operation;
  resourceType: ResourceType;
};

export type Organization = {
  __typename?: 'Organization';
  created: Modification;
  customer?: Maybe<Customer>;
  id: Scalars['LongEntityId']['output'];
  institutions?: Maybe<Array<Institution>>;
  modified?: Maybe<Modification>;
  name: Scalars['String']['output'];
  oid?: Maybe<Scalars['ObjectId']['output']>;
};

/**
 * OrganizationFilter is used when filtering from the perspective of a organization using no filter, from the
 * perspective of an admin or a customer filtering for a specific organization
 */
export type OrganizationFilter = {
  customer: Scalars['ObjectId']['input'];
  organization: Scalars['ObjectId']['input'];
};

export type OrganizationLevel = {
  cid: Scalars['Cid']['input'];
  oid: Scalars['Oid']['input'];
};

export type OrganizationUnit = {
  __typename?: 'OrganizationUnit';
  created: Modification;
  customer?: Maybe<Customer>;
  id: Scalars['LongEntityId']['output'];
  institutions?: Maybe<Array<Institution>>;
  members: Array<MemberId>;
  modified?: Maybe<Modification>;
  name: Scalars['String']['output'];
  oid?: Maybe<Scalars['ObjectId']['output']>;
  uid?: Maybe<Scalars['ObjectId']['output']>;
};

export type OrganizationUnitLevel = {
  cid: Scalars['Cid']['input'];
  oid: Scalars['Oid']['input'];
  uid: Scalars['Uid']['input'];
};

export enum PaymentMethod {
  Bz = 'BZ',
  Ls = 'LS',
  Uw = 'UW'
}

/** The GraphQL version for [`Role`] with actual container types */
export type Permission = FunctionalPermission | OperationalPermission;

/** The GraphQL version for [`Role`] with actual container types */
export type PermissionInput = {
  functional?: InputMaybe<FunctionalPermissionInput>;
  operational?: InputMaybe<OperationalPermissionInput>;
};

export type Person = {
  __typename?: 'Person';
  citizenships?: Maybe<Array<Scalars['String']['output']>>;
  denomination?: Maybe<Scalars['String']['output']>;
  familyLanguageIsNotGerman?: Maybe<Scalars['Boolean']['output']>;
  firstname: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  lastname: Scalars['String']['output'];
  middlename?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PersonInput = {
  citizenships?: InputMaybe<Array<Scalars['String']['input']>>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  familyLanguageIsNotGerman?: InputMaybe<Scalars['Boolean']['input']>;
  firstname: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastname: Scalars['String']['input'];
  middlename?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Collects information about the places available in an institution.
 *
 * This is **not** representing a place!
 */
export type Place = {
  __typename?: 'Place';
  adolescent?: Maybe<Scalars['Int']['output']>;
  approved?: Maybe<Scalars['Int']['output']>;
  general?: Maybe<Scalars['Int']['output']>;
  integrative?: Maybe<Scalars['Int']['output']>;
  meal?: Maybe<Scalars['Int']['output']>;
  schoolChildren?: Maybe<Scalars['Int']['output']>;
  toddler?: Maybe<Scalars['Int']['output']>;
};

export enum PlaceNecessity {
  Three = 'THREE',
  TwoPointFive = 'TWO_POINT_FIVE'
}

export enum Portal {
  Kitalino = 'KITALINO',
  Kitaplaner = 'KITAPLANER',
  KitaplatzPilot = 'KITAPLATZ_PILOT',
  Kivan = 'KIVAN',
  LittleBird = 'LITTLE_BIRD'
}

export enum Position {
  /** "Sonstige Fachkraft" */
  A = 'A',
  /** "Berufspraktikant/in - Ergänzungskraft" */
  B = 'B',
  /** "Sonstige (nicht im Anstellungsschlüssel)" */
  D = 'D',
  /** "Erzieher/in - Fachkraft" */
  E = 'E',
  /** "Freigestellte Einrichtungsleitung (Leitungs- und Verwaltungsbonus)" */
  F = 'F',
  /** "Sonstige Ergänzungskraft" */
  G = 'G',
  /** "Heilpädagog/e/in - Fachkraft (nur bei integrativen Einrichtungen)" */
  H = 'H',
  /** "Sozialpädagogisches Einführungsjahr (SEJ)" */
  J = 'J',
  /** "Kinderpfleger/in - Ergänzungskraft" */
  K = 'K',
  /** "hauswirtschaftl.- technisches Personal" */
  N = 'N',
  /** "OptiPrax-Praktikant/in - Ergänzungskraft (anrechenbare Stunden angeben!)" */
  O = 'O',
  /** "Heilerziehungspfleger/in - Fachkraft (nur bei integrativen Einrichtungen)" */
  P = 'P',
  /** "Sozialpädagog/e/in - Fachkraft" */
  S = 'S',
  /** "Assistenzkraft (nicht im AS und FKQ)" */
  T = 'T',
  /** "Zusatzkraft für Einzelintegration (nicht im AS und FKQ, nur für Statistik) */
  U = 'U',
  /** "Erzieherpraktikant/in (SPS)" */
  V = 'V',
  /** "Verwaltungspersonal" */
  W = 'W',
  /** "Sprachfachkraft (Schwerpunktfachkraft bis Juni 2023)" */
  Y = 'Y',
  /** "Zusatzkraft (integrative Einrichtungen)" */
  Z = 'Z'
}

export enum PreCourse {
  BothKgj = 'BOTH_KGJ',
  FirstKgj = 'FIRST_KGJ',
  No = 'NO',
  SecondKgj = 'SECOND_KGJ'
}

export type Presence = {
  __typename?: 'Presence';
  /**
   * Get the associated [`Child`] object.
   *
   * Requires rights to the `child` resource.
   */
  child?: Maybe<Child>;
  childId: Scalars['ObjectId']['output'];
  date: Scalars['DateTime']['output'];
  kind: PresenceKind;
  pickedUp: Scalars['Boolean']['output'];
  rid: Scalars['LongEntityId']['output'];
};

export type PresenceComplete = {
  __typename?: 'PresenceComplete';
  complete: Scalars['Boolean']['output'];
  date: Scalars['YearMonth']['output'];
  rid: Scalars['LongEntityId']['output'];
};

export enum PresenceKind {
  Absent = 'ABSENT',
  AbsentAndExcused = 'ABSENT_AND_EXCUSED',
  Present = 'PRESENT',
  PresentWithMeal = 'PRESENT_WITH_MEAL'
}

export enum Priority {
  Eight = 'EIGHT',
  Five = 'FIVE',
  Four = 'FOUR',
  Nine = 'NINE',
  One = 'ONE',
  Seven = 'SEVEN',
  Six = 'SIX',
  Three = 'THREE',
  Two = 'TWO'
}

export type ProjectCustomer = {
  __typename?: 'ProjectCustomer';
  additionalAddress?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<SimpleAddress>;
  cid?: Maybe<Scalars['ObjectId']['output']>;
  contactPersons?: Maybe<Array<ContactPerson>>;
  created: Modification;
  customerNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type ProjectCustomerList = {
  __typename?: 'ProjectCustomerList';
  items: Array<ProjectCustomer>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ProjectInstitution = {
  __typename?: 'ProjectInstitution';
  additionalAddress?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<SimpleAddress>;
  banks?: Maybe<Array<Bank>>;
  /**
   * Get the associated [`Commune`](Commune).
   *
   * Requires rights to the `commune` resource.
   */
  commune?: Maybe<Commune>;
  communeId?: Maybe<Scalars['ObjectId']['output']>;
  contactPersons?: Maybe<Array<ContactPerson>>;
  created: Modification;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  iid?: Maybe<Scalars['ObjectId']['output']>;
  institutionNumber?: Maybe<Scalars['String']['output']>;
  internalInstitutionNumber?: Maybe<Scalars['String']['output']>;
  kibigKey?: Maybe<Scalars['String']['output']>;
  launchDate?: Maybe<Scalars['NaiveDate']['output']>;
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  openingHours?: Maybe<OpeningHours>;
  operatingPermitYear?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Place>;
  /**
   * Get the associated [sections](`InstitutionSection`).
   *
   * Requires rights to the `institution` resource.
   */
  sections?: Maybe<Array<InstitutionSection>>;
  sepaConfiguration?: Maybe<SepaConfiguration>;
  statistics?: Maybe<Statistics>;
  terminationDate?: Maybe<Scalars['NaiveDate']['output']>;
  type: InstitutionType;
  yearOfConstruction?: Maybe<Scalars['String']['output']>;
};

export type ProjectInstitutionList = {
  __typename?: 'ProjectInstitutionList';
  items: Array<ProjectInstitution>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ProjectOrganization = {
  __typename?: 'ProjectOrganization';
  additionalAddress?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<SimpleAddress>;
  contactPersons?: Maybe<Array<ContactPerson>>;
  created: Modification;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  institutions?: Maybe<Array<Institution>>;
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberOfMembers?: Maybe<Scalars['Int']['output']>;
  oid?: Maybe<Scalars['ObjectId']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ProjectOrganizationList = {
  __typename?: 'ProjectOrganizationList';
  items: Array<ProjectOrganization>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ProjectOrganizationUnit = {
  __typename?: 'ProjectOrganizationUnit';
  created: Modification;
  customer?: Maybe<Customer>;
  id: Scalars['LongEntityId']['output'];
  institutions?: Maybe<Array<Institution>>;
  members: Array<MemberId>;
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  oid?: Maybe<Scalars['ObjectId']['output']>;
  uid?: Maybe<Scalars['ObjectId']['output']>;
};

export type ProjectOrganizationUnitList = {
  __typename?: 'ProjectOrganizationUnitList';
  items: Array<ProjectOrganizationUnit>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

/** An owned version of an RcObject, used to send to the frontend to add data such as `id`, `organization`, `institution` and `linked_to`. */
export type Qualification = {
  __typename?: 'Qualification';
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  /** Get [Institutions](Institution) this object is linked to. */
  linkedTo: Array<Institution>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  type: Scalars['String']['output'];
};

export type QualificationList = {
  __typename?: 'QualificationList';
  items: Array<Qualification>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type QueryRoot = {
  __typename?: 'QueryRoot';
  /** Requires the `fee:view` right. */
  accountingGroupById: AccountingGroup;
  /** Requires the `fee:list` right. */
  accountingGroups: AccountingGroupList;
  /** Requires the `fee:list` right. */
  accountingRuns: AccountingRunList;
  /** Requires the `address:view` right. */
  addressById: Address;
  /** Requires the `address:list` right. */
  addresses: AddressList;
  /** Requires the `analysis:list` right. */
  analyses: AnalysisList;
  /** Requires the `analysis:view` right. */
  analysisById: Analysis;
  /** Requires the `appointment:view` right. */
  appointmentById: Appointment;
  /** Requires the `appointment:list` right. */
  appointments: AppointmentList;
  /**
   * Get appointments with filters.
   *
   * Requires the `appointment:list` right.
   *
   * Filter `from` and `to` are **inclusive**.
   */
  appointmentsFiltered: Array<Appointment>;
  /**
   * Get all children with birthday in the previous and next days.
   *
   * Requires the `child:list` right.
   *
   * If no `day_offset` is provided, `30` days are assumed.
   */
  birthdays: ChildList;
  /** Requires the `booking:view` right. */
  bookingById: Booking;
  /** Requires the `booking:view` right. */
  bookingDays: Array<BookingDay>;
  /** Requires the `booking:list` right. */
  bookings: BookingList;
  /** Requires the `category:list` right. */
  categories: CategoryList;
  /** Requires the `category:view` right. */
  categoryById: Category;
  /** Requires the `characteristic:list` right. */
  characteristics: CharacteristicList;
  /** Requires the `child:view` right. */
  childById: Child;
  /** Requires the `child:list` right. */
  children: ChildList;
  /** Requires the `commune:view` right. */
  communeById: Commune;
  /** Requires the `commune:list` right. */
  communes: CommuneList;
  /** Resolves the effective configuration at the given context, taking into account institution, organization, customer and system configuration. */
  configuration: Configuration;
  /**
   * Resolves the editable configuration meta for customers, organizations or institutions.
   * An empty `meta_context` applies to all customers, a cid-only one to all organizations under
   * that customer, and one with cid and oid to all institutions under that organization.
   * The non-editable, system-level writable/visible meta can be read from the `configuration_schema` query.
   */
  configurationMeta: ConfigurationMeta;
  configurationSchema: ConfigurationSchema;
  /** Requires the `child:list` right. */
  custodians: CustodianList;
  /** Requires the `customer:view` right. */
  customerById: ProjectCustomer;
  /** Requires the `customer:view` right. */
  customerByName: ProjectCustomer;
  /** Requires the `customer:list` right. */
  customers: ProjectCustomerList;
  /** Requires the `contract:list` right. */
  debtors: DebtorList;
  /** Requires the `employee:view` right. */
  employeeById: Employee;
  /** Requires the `employee:list` right. */
  employees: EmployeeList;
  /** Requires the `employment:view` right. */
  employmentById: Employment;
  /** Requires the `employment:list` right. */
  employments: EmploymentList;
  /** Requires the `fee:view` right. */
  feeDraftById: FeeDraft;
  /** Requires the `fee:list` right. */
  feeDrafts: FeeDraftList;
  /** Requires the `fee:view` right. */
  feeTypeById: FeeType;
  /** Requires the `fee:list` right. */
  feeTypes: FeeTypeList;
  /** Requires the `food_type:view` right. */
  foodTypeById: FoodType;
  /** Requires the `food_type:list` right. */
  foodTypes: FoodTypeList;
  /** Requires the `group:view` right. */
  groupById: Group;
  /** Requires the `group:list` right. */
  groups: GroupList;
  /**
   * Get holidays in range.
   *
   * Requires the `institution:view` right.
   *
   * Arguments `from` and `to` are **inclusive**.
   */
  holidaysInRange: Array<Holiday>;
  /** Requires the `inbox_child:view` right. */
  inboxChildById: InboxChild;
  /** Requires the `inbox_child:list` right. */
  inboxChildren: InboxChildList;
  /** Requires the `institution:view` right. */
  institutionById: ProjectInstitution;
  /** Requires the `institution:view` right. */
  institutionByName: ProjectInstitution;
  institutionStatisticalDetails: InstitutionStatisticalDetails;
  /** Requires the `institution:list` right. */
  institutions: ProjectInstitutionList;
  /** Requires the `contract:list` right. */
  mainDebtors: MainDebtorList;
  /**
   * Generate a new valid sepa mandate reference.
   *
   * Requires the `fee:view` right.
   */
  newSepaMandateReference: Scalars['String']['output'];
  note: Scalars['String']['output'];
  /** Requires the `organization:view` right. */
  organizationById: ProjectOrganization;
  /** Requires the `organization:view` right. */
  organizationByName: ProjectOrganization;
  /** Requires the `organization_units:view` right. */
  organizationUnitById: ProjectOrganizationUnit;
  /** Requires the `organization_units:list` right. */
  organizationUnits: ProjectOrganizationUnitList;
  /** Requires the `organization:list` right. */
  organizations: ProjectOrganizationList;
  /** Requires the `child:list` right. */
  presences: Array<ChildPresences>;
  presencesComplete: Array<PresenceComplete>;
  /** Requires the `qualification:view` right. */
  qualificationById: Qualification;
  /** Requires the `qualification:list` right. */
  qualifications: QualificationList;
  rawCustomerConfiguration?: Maybe<Configuration>;
  rawInstitutionConfiguration?: Maybe<Configuration>;
  rawOrganizationConfiguration?: Maybe<Configuration>;
  rawSystemConfiguration?: Maybe<Configuration>;
  /** Requires the `receipt_view` right. */
  receiptById: Receipt;
  /** Requires the `receipt_view` right. */
  receipts: ReceiptList;
  /** Requires the `role:view` right. */
  roleById: Role;
  /** Requires the `role:list` right. */
  roles: RoleList;
  /** Requires the `school:view` right. */
  schoolById: School;
  /** Get school holidays. */
  schoolHolidays: Array<SchoolHoliday>;
  /** Requires the `school:list` right. */
  schools: SchoolList;
  /** Requires the `fee:list` right. */
  sepaMandates: SepaMandateList;
  /** Requires the `service_type:view` right. */
  serviceTypeById: ServiceType;
  /** Requires the `service_type:list` right. */
  serviceTypes: ServiceTypeList;
  tableFilters: TableFilterList;
  tablePresets: TablePresetList;
  /** Requires the `user:view` right. */
  userById: User;
  /** Requires the `user:list` right. */
  users: UserList;
  /** Requires the `youth_welfare_office:view` right. */
  youthWelfareOfficeById: YouthWelfareOffice;
  /** Requires the `youth_welfare_office:list` right. */
  youthWelfareOffices: YouthWelfareOfficeList;
};


export type QueryRootAccountingGroupByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootAccountingGroupsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootAccountingRunsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootAddressByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootAddressesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootAnalysesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootAnalysisByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootAppointmentByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootAppointmentsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootAppointmentsFilteredArgs = {
  context?: InputMaybe<ContextFilter>;
  filter: AppointmentQueryFilter;
};


export type QueryRootBirthdaysArgs = {
  context?: InputMaybe<ContextFilter>;
  dayOffset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootBookingByIdArgs = {
  context?: InputMaybe<ContextFilter>;
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootBookingDaysArgs = {
  childId: Scalars['StrictEntityId']['input'];
  from: Scalars['NaiveDate']['input'];
  to: Scalars['NaiveDate']['input'];
};


export type QueryRootBookingsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootCategoriesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootCategoryByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootCharacteristicsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootChildByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootChildrenArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootCommuneByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootCommunesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootConfigurationArgs = {
  context: ContextFilter;
};


export type QueryRootConfigurationMetaArgs = {
  metaContext?: InputMaybe<ContextFilter>;
};


export type QueryRootCustodiansArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootCustomerByIdArgs = {
  id: StrictCustomerId;
};


export type QueryRootCustomerByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryRootCustomersArgs = {
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootDebtorsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootEmployeeByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootEmployeesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootEmploymentByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootEmploymentsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootFeeDraftByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootFeeDraftsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootFeeTypeByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootFeeTypesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootFoodTypeByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootFoodTypesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootGroupByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootGroupsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootHolidaysInRangeArgs = {
  context: InstitutionFilter;
  from: Scalars['NaiveDate']['input'];
  to: Scalars['NaiveDate']['input'];
};


export type QueryRootInboxChildByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootInboxChildrenArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootInstitutionByIdArgs = {
  id: StrictInstitutionId;
};


export type QueryRootInstitutionByNameArgs = {
  context: ContextFilter;
  name: Scalars['String']['input'];
};


export type QueryRootInstitutionStatisticalDetailsArgs = {
  institutionStatisticalDetailsFilter: InstitutionStatisticalDetailsFilter;
};


export type QueryRootInstitutionsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootMainDebtorsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootNewSepaMandateReferenceArgs = {
  childId: Scalars['StrictEntityId']['input'];
  context: InstitutionFilter;
  financialAccountingData?: FinancialAccountingDataInput;
};


export type QueryRootOrganizationByIdArgs = {
  id: StrictOrganizationId;
};


export type QueryRootOrganizationByNameArgs = {
  context: ContextFilter;
  name: Scalars['String']['input'];
};


export type QueryRootOrganizationUnitByIdArgs = {
  context?: InputMaybe<ContextFilter>;
  id: StrictOrganizationUnitId;
};


export type QueryRootOrganizationUnitsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootOrganizationsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootPresencesArgs = {
  context: InstitutionFilter;
  from: Scalars['NaiveDate']['input'];
  to: Scalars['NaiveDate']['input'];
};


export type QueryRootPresencesCompleteArgs = {
  context: InstitutionFilter;
  date?: InputMaybe<Scalars['YearMonth']['input']>;
};


export type QueryRootQualificationByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootQualificationsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootRawCustomerConfigurationArgs = {
  context: CustomerFilter;
};


export type QueryRootRawInstitutionConfigurationArgs = {
  context: InstitutionFilter;
};


export type QueryRootRawOrganizationConfigurationArgs = {
  context: OrganizationFilter;
};


export type QueryRootReceiptByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootReceiptsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootRoleByIdArgs = {
  id: Scalars['RoleId']['input'];
};


export type QueryRootRolesArgs = {
  context?: InputMaybe<ContextFilter>;
};


export type QueryRootSchoolByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootSchoolHolidaysArgs = {
  from: Scalars['NaiveDate']['input'];
  to: Scalars['NaiveDate']['input'];
};


export type QueryRootSchoolsArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootSepaMandatesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootServiceTypeByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootServiceTypesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootTableFiltersArgs = {
  filter?: InputMaybe<ListFilter>;
  table?: InputMaybe<TableFilterTable>;
};


export type QueryRootTablePresetsArgs = {
  filter?: InputMaybe<ListFilter>;
  table?: InputMaybe<Table>;
};


export type QueryRootUserByIdArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryRootUsersArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};


export type QueryRootYouthWelfareOfficeByIdArgs = {
  id: Scalars['StrictEntityId']['input'];
};


export type QueryRootYouthWelfareOfficesArgs = {
  context?: InputMaybe<ContextFilter>;
  filter?: InputMaybe<ListFilter>;
};

export type Queued = {
  __typename?: 'Queued';
  priority: Priority;
};

export type QueuedInput = {
  priority: Priority;
};

export type Receipt = {
  __typename?: 'Receipt';
  /**
   * Get the associated [`AccountingRun`]
   *
   * Requires the right to access the `fee` resource.
   */
  accountingRun: AccountingRun;
  blocks: Array<ReceiptBlock>;
  date: Scalars['NaiveDate']['output'];
  debtor: ReceiptDebtor;
  id: Scalars['LongEntityId']['output'];
  n: Scalars['Int']['output'];
  paymentData: ReceiptPaymentData;
  /** A displayable string generated to match a template string defined by the institution */
  receiptDisplayNumber?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  yearMonth: Scalars['YearMonth']['output'];
};

/**
 * A block in the receipt.
 *
 * A "debtor" can pay for multiple children, each of them get a seperate block.
 * It depends on the `collectiveInvoice` flag whether a receipt contains only one block or multiple.
 */
export type ReceiptBlock = {
  __typename?: 'ReceiptBlock';
  child: ReceiptBlockChild;
  months: Array<ReceiptBlockMonth>;
};

/**
 * Information about the child, that the fees have been paid for.
 *
 * At this moment, we disregard the contract.
 */
export type ReceiptBlockChild = {
  __typename?: 'ReceiptBlockChild';
  birthdate: Scalars['NaiveDate']['output'];
  childId: Scalars['ObjectId']['output'];
  debtorNumber: Scalars['Int']['output'];
  financialAccountingData: FinancialAccountingData;
  name: Scalars['String']['output'];
};

/** The name of the fee and the amounts the "debtor" paid. */
export type ReceiptBlockFee = {
  __typename?: 'ReceiptBlockFee';
  amounts: Array<Scalars['Float']['output']>;
  feeId: Scalars['ObjectId']['output'];
  /**
   * Store the full original fee value for reporting purposes.
   * This does not describe _what_ the debtor is paying, but the service they are paying for.
   */
  originalValue: FeeValue;
  text: Scalars['String']['output'];
};

export type ReceiptBlockMonth = {
  __typename?: 'ReceiptBlockMonth';
  fees: Array<ReceiptBlockFee>;
  /** "Aktenzeichen" */
  reference?: Maybe<Scalars['String']['output']>;
  yearMonth: Scalars['YearMonth']['output'];
};

/**
 * General "debtor" information.
 *
 * Importantly, the id is included, to retrieve the receipts later on.
 *
 * A "debtor" in the context of the receipts is one of the following:
 * 1. A custodian (this is different to a usual debtor),
 * 2. an employer,
 * 3. or a youth welfare office.
 *
 * Also, we don't discriminate between "main debtors" or "additional debtors" here.
 * Everyone who pays is treated equally regarding receipts.
 */
export type ReceiptDebtor = {
  __typename?: 'ReceiptDebtor';
  address: SimpleAddress;
  collectiveInvoice: Scalars['Boolean']['output'];
  custodian: Scalars['Boolean']['output'];
  debtorNumber: Scalars['Int']['output'];
  financialAccountingData: FinancialAccountingData;
  name: Scalars['String']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
};

export enum ReceiptDebtorType {
  Address = 'ADDRESS',
  Custodian = 'CUSTODIAN',
  YouthWelfareOffice = 'YOUTH_WELFARE_OFFICE'
}

export type ReceiptList = {
  __typename?: 'ReceiptList';
  items: Array<Receipt>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

/** The payment data that was used by the debtor to pay the fees included in the blocks */
export type ReceiptPaymentData = {
  __typename?: 'ReceiptPaymentData';
  bic?: Maybe<Scalars['Bic']['output']>;
  iban?: Maybe<Scalars['Iban']['output']>;
  paymentMethod: PaymentMethod;
  sepaMandateCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  sepaMandateReference?: Maybe<Scalars['String']['output']>;
};

export enum Region {
  Mf = 'MF',
  Nb = 'NB',
  Ob = 'OB',
  Of = 'OF',
  Op = 'OP',
  Sw = 'SW',
  Uf = 'UF'
}

export type Rejected = {
  __typename?: 'Rejected';
  at: Scalars['NaiveDate']['output'];
};

export type RejectedInput = {
  at: Scalars['NaiveDate']['input'];
};

export enum Relation {
  Father = 'father',
  Grandfather = 'grandfather',
  Grandmother = 'grandmother',
  Mother = 'mother',
  Neighbor = 'neighbor',
  Stepfather = 'stepfather',
  Stepmother = 'stepmother'
}

/** "Beitragserhebung" */
export enum Repetition {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Variable = 'VARIABLE',
  Yearly = 'YEARLY'
}

export enum RequiredUserAction {
  UpdatePassword = 'UPDATE_PASSWORD'
}

export type Reserved = {
  __typename?: 'Reserved';
  confirmed?: Maybe<Confirmed>;
};

export type ReservedInput = {
  confirmed?: InputMaybe<ConfirmedInput>;
};

export enum ResourceType {
  Address = 'address',
  Analysis = 'analysis',
  Appointment = 'appointment',
  Booking = 'booking',
  Category = 'category',
  Characteristic = 'characteristic',
  Child = 'child',
  Commune = 'commune',
  Contract = 'contract',
  Customer = 'customer',
  Employee = 'employee',
  Employment = 'employment',
  Fee = 'fee',
  FoodType = 'food_type',
  Group = 'group',
  InboxChild = 'inbox_child',
  Institution = 'institution',
  Organization = 'organization',
  OrganizationUnit = 'organization_unit',
  Qualification = 'qualification',
  Role = 'role',
  School = 'school',
  ServiceType = 'service_type',
  User = 'user',
  YouthWelfareOffice = 'youth_welfare_office'
}

export type Role = {
  __typename?: 'Role';
  accessLevel: AccessLevel;
  cid?: Maybe<Scalars['Cid']['output']>;
  id: Scalars['RoleId']['output'];
  n?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  permissions: Array<Permission>;
};

export type RoleList = {
  __typename?: 'RoleList';
  items: Array<Role>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export enum RuralKita {
  Ten = 'TEN',
  TwentyFive = 'TWENTY_FIVE'
}

/** An owned version of an RcObject, used to send to the frontend to add data such as `id`, `organization`, `institution` and `linked_to`. */
export type School = {
  __typename?: 'School';
  additionalAddress?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<SimpleAddress>;
  contactPerson?: Maybe<ContactPerson>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['LongEntityId']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  /** Get [Institutions](Institution) this object is linked to. */
  linkedTo: Array<Institution>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  phone?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type SchoolData = {
  __typename?: 'SchoolData';
  className?: Maybe<Scalars['String']['output']>;
  /**
   * Get the associated [`School`](School).
   *
   * Requires rights to the `School` resource.
   */
  school?: Maybe<School>;
  schoolId: Scalars['StrictEntityId']['output'];
};

export type SchoolHoliday = {
  __typename?: 'SchoolHoliday';
  endDate: Scalars['NaiveDate']['output'];
  id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['NaiveDate']['output'];
  state: Scalars['String']['output'];
};

export type SchoolList = {
  __typename?: 'SchoolList';
  items: Array<School>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type SectionTime = {
  __typename?: 'SectionTime';
  /** Requires the rights to the `institution` resource. */
  institutionSection: InstitutionSection;
  institutionSectionId: Scalars['StrictEntityId']['output'];
  time: Scalars['Float']['output'];
};

export type SectionTimeInput = {
  institutionSectionId: Scalars['StrictEntityId']['input'];
  time: Scalars['Float']['input'];
};

export type SepaConfiguration = {
  __typename?: 'SepaConfiguration';
  paymentInstitution?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  sepaCreditorIdentificationNumber?: Maybe<Scalars['String']['output']>;
};

export type SepaMandate = {
  __typename?: 'SepaMandate';
  /** Requires the `child:list` right. */
  children: Array<Child>;
  created: Modification;
  createdAt: Scalars['NaiveDate']['output'];
  custodian: Custodian;
  id: Scalars['LongEntityId']['output'];
  latestUsage?: Maybe<Scalars['NaiveDate']['output']>;
  modified?: Maybe<Modification>;
  n: Scalars['Int']['output'];
  previousSepaMandateId?: Maybe<Scalars['ObjectId']['output']>;
  /**
   * SEPA mandate reference
   *
   * Unique within the "Creditor Identifier" ("Gläubiger-Identifikationsnummer"), i.e. the context of one institution.
   */
  sepaMandateReference: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
  validFrom: Scalars['NaiveDate']['output'];
  validTo?: Maybe<Scalars['NaiveDate']['output']>;
};

export type SepaMandateList = {
  __typename?: 'SepaMandateList';
  items: Array<SepaMandate>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

/** An owned version of an RcObject, used to send to the frontend to add data such as `id`, `organization`, `institution` and `linked_to`. */
export type ServiceType = {
  __typename?: 'ServiceType';
  bgcolor: Scalars['String']['output'];
  id: Scalars['LongEntityId']['output'];
  identifier: Scalars['String']['output'];
  /**
   * Get the associated [`Institution`](ProjectInstitution).
   *
   * Requires rights to the `institution` resource.
   */
  institution?: Maybe<ProjectInstitution>;
  /** Get [Institutions](Institution) this object is linked to. */
  linkedTo: Array<Institution>;
  n: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /**
   * Get the associated [`Organization`](ProjectOrganization).
   *
   * Requires rights to the `organization` resource.
   */
  organization?: Maybe<ProjectOrganization>;
  times: TimeRange;
  type: Scalars['String']['output'];
};

export type ServiceTypeList = {
  __typename?: 'ServiceTypeList';
  items: Array<ServiceType>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ShortTime = {
  __typename?: 'ShortTime';
  bookingDays: BookingDays;
  /** This will reflect the variant of the `BookingDays` object */
  bookingDaysEnum: BookingDaysEnum;
  communeId?: Maybe<Scalars['StrictEntityId']['output']>;
};

export type ShortTimeInput = {
  bookingDays: BookingDaysInput;
  communeId?: InputMaybe<Scalars['StrictEntityId']['input']>;
};

/** In the future, this will probably also contain the start date of the contract. */
export type Signed = {
  __typename?: 'Signed';
  at: Scalars['NaiveDate']['output'];
};

/** In the future, this will probably also contain the start date of the contract. */
export type SignedInput = {
  at: Scalars['NaiveDate']['input'];
};

export type SimpleAddress = {
  __typename?: 'SimpleAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type SimpleAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type SimpleAmount = {
  __typename?: 'SimpleAmount';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type SimpleAmountInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
};

export type Standard = {
  __typename?: 'Standard';
  communeId?: Maybe<Scalars['StrictEntityId']['output']>;
  slotSplitting: Scalars['Boolean']['output'];
};

export type StandardInput = {
  communeId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  slotSplitting: Scalars['Boolean']['input'];
};

export type Statistics = {
  __typename?: 'Statistics';
  close?: Maybe<Scalars['NaiveTime']['output']>;
  closeMidday?: Maybe<Scalars['Boolean']['output']>;
  companyEmployees?: Maybe<Scalars['Boolean']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  notFixedStructure?: Maybe<Scalars['Boolean']['output']>;
  open?: Maybe<Scalars['NaiveTime']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  parentInitiatives?: Maybe<Scalars['Boolean']['output']>;
  regionalNumber?: Maybe<Scalars['Int']['output']>;
  statisticalNumber?: Maybe<Scalars['String']['output']>;
};

export type StatisticsAreaWorkingHours = {
  __typename?: 'StatisticsAreaWorkingHours';
  area: Area;
  hours: Scalars['Float']['output'];
};

export type StatisticsAreaWorkingHoursInput = {
  area: Area;
  hours: Scalars['Float']['input'];
};

export type StrictCustomerId = {
  cid: Scalars['ObjectId']['input'];
};

export type StrictInstitutionId = {
  cid: Scalars['ObjectId']['input'];
  iid: Scalars['ObjectId']['input'];
  oid: Scalars['ObjectId']['input'];
};

export type StrictOrganizationId = {
  cid: Scalars['ObjectId']['input'];
  oid: Scalars['ObjectId']['input'];
};

export type StrictOrganizationUnitId = {
  cid: Scalars['ObjectId']['input'];
  oid?: InputMaybe<Scalars['ObjectId']['input']>;
  uid: Scalars['ObjectId']['input'];
};

/** If used as an input argument in GraphQL, exactly one of the fields must be provided. */
export type Substate = Created | Signed;

/** If used as an input argument in GraphQL, exactly one of the fields must be provided. */
export type SubstateInput = {
  created?: InputMaybe<CreatedInput>;
  signed?: InputMaybe<SignedInput>;
};

/** Every possible table in the application, that might need a preset */
export enum Table {
  AccountingGroups = 'ACCOUNTING_GROUPS',
  Addresses = 'ADDRESSES',
  Appointments = 'APPOINTMENTS',
  Banks = 'BANKS',
  Bookings = 'BOOKINGS',
  Categories = 'CATEGORIES',
  Characteristics = 'CHARACTERISTICS',
  Children = 'CHILDREN',
  Communes = 'COMMUNES',
  Custodians = 'CUSTODIANS',
  Customers = 'CUSTOMERS',
  Employees = 'EMPLOYEES',
  EmployeeQualifications = 'EMPLOYEE_QUALIFICATIONS',
  Employments = 'EMPLOYMENTS',
  FeeDrafts = 'FEE_DRAFTS',
  FeeReceipts = 'FEE_RECEIPTS',
  FeeTypes = 'FEE_TYPES',
  FoodTypes = 'FOOD_TYPES',
  Groups = 'GROUPS',
  InboxChildren = 'INBOX_CHILDREN',
  Institutions = 'INSTITUTIONS',
  Organizations = 'ORGANIZATIONS',
  OrganizationUnits = 'ORGANIZATION_UNITS',
  Qualifications = 'QUALIFICATIONS',
  Roles = 'ROLES',
  Schools = 'SCHOOLS',
  SepaMandates = 'SEPA_MANDATES',
  ServiceTypes = 'SERVICE_TYPES',
  Users = 'USERS',
  YouthWelfareOffices = 'YOUTH_WELFARE_OFFICES'
}

export type TableFilter = {
  __typename?: 'TableFilter';
  columns: Array<Scalars['String']['output']>;
  id: Scalars['ObjectId']['output'];
  isGlobal: Scalars['Boolean']['output'];
  isGlobalDefault: Scalars['Boolean']['output'];
  isUserDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  table: TableFilterTable;
};

export type TableFilterList = {
  __typename?: 'TableFilterList';
  items: Array<TableFilter>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export enum TableFilterTable {
  Addresses = 'ADDRESSES',
  Appointments = 'APPOINTMENTS',
  Bookings = 'BOOKINGS',
  Children = 'CHILDREN',
  Custodian = 'CUSTODIAN',
  Employees = 'EMPLOYEES',
  EmployeeQualifications = 'EMPLOYEE_QUALIFICATIONS',
  Employments = 'EMPLOYMENTS',
  FeeReceipts = 'FEE_RECEIPTS',
  Qualifications = 'QUALIFICATIONS',
  SepaMandates = 'SEPA_MANDATES'
}

export type TablePreset = {
  __typename?: 'TablePreset';
  columns: Array<Scalars['String']['output']>;
  id: Scalars['ObjectId']['output'];
  isGlobal: Scalars['Boolean']['output'];
  isGlobalDefault: Scalars['Boolean']['output'];
  isUserDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  table: Table;
};

export type TablePresetList = {
  __typename?: 'TablePresetList';
  items: Array<TablePreset>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type Terminated = {
  __typename?: 'Terminated';
  at: Scalars['NaiveDate']['output'];
  reason: Scalars['String']['output'];
  terminationDate: Scalars['NaiveDate']['output'];
};

export type TerminatedInput = {
  at: Scalars['NaiveDate']['input'];
  reason: Scalars['String']['input'];
  terminationDate: Scalars['NaiveDate']['input'];
};

export type TimeFactorData = {
  __typename?: 'TimeFactorData';
  category: BookingTimeCategory;
  daysPerWeek: Scalars['Int']['output'];
  hoursPerWeek: Scalars['Float']['output'];
};

export type TimeRange = {
  __typename?: 'TimeRange';
  end?: Maybe<Scalars['NaiveTime']['output']>;
  start?: Maybe<Scalars['NaiveTime']['output']>;
};

export type TimeRangeInput = {
  end?: InputMaybe<Scalars['NaiveTime']['input']>;
  start?: InputMaybe<Scalars['NaiveTime']['input']>;
};

export type Times = {
  __typename?: 'Times';
  fr?: Maybe<Array<TimeRange>>;
  mo?: Maybe<Array<TimeRange>>;
  sa?: Maybe<Array<TimeRange>>;
  su?: Maybe<Array<TimeRange>>;
  th?: Maybe<Array<TimeRange>>;
  tu?: Maybe<Array<TimeRange>>;
  we?: Maybe<Array<TimeRange>>;
};

export type TimesInput = {
  fr?: InputMaybe<Array<TimeRangeInput>>;
  mo?: InputMaybe<Array<TimeRangeInput>>;
  sa?: InputMaybe<Array<TimeRangeInput>>;
  su?: InputMaybe<Array<TimeRangeInput>>;
  th?: InputMaybe<Array<TimeRangeInput>>;
  tu?: InputMaybe<Array<TimeRangeInput>>;
  we?: InputMaybe<Array<TimeRangeInput>>;
};

export type UpdateAccountingGroupInput = {
  /**
   * "Abrechnen zum"
   * -1 represents "monatsletzten".
   * 0 represents "null".
   * 1 up to 31 represents the day of the month.
   */
  accountAtDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** "Beitragsschema-ID" */
  accountingGroupId?: InputMaybe<Scalars['String']['input']>;
  /** "Bereich" */
  category?: InputMaybe<GeneralFeeCategory>;
  /** "monatliche Erhebung: Anzahl Monate" */
  months?: InputMaybe<Months>;
  /** "Bezeichnung" */
  name?: InputMaybe<Scalars['String']['input']>;
  /** "Beitragserhebung" */
  repetition?: InputMaybe<Repetition>;
};

export type UpdateAddressInput = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  bankInstitution?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['Bic']['input']>;
  birthdate?: InputMaybe<Scalars['NaiveDate']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  collectiveInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<UpdateContactInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  doctor?: InputMaybe<Scalars['Boolean']['input']>;
  employer?: InputMaybe<Scalars['Boolean']['input']>;
  externalAddress?: InputMaybe<Scalars['Boolean']['input']>;
  externalPayer?: InputMaybe<Scalars['Boolean']['input']>;
  facility?: InputMaybe<Scalars['String']['input']>;
  financialAccountingData?: InputMaybe<UpdateFinancialAccountingDataInput>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['Iban']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  otherAddress?: InputMaybe<Scalars['Boolean']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  specialService?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  volunteer?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerDescription?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAnalysisInput = {
  children?: InputMaybe<Array<AnalysisChildInput>>;
  employees?: InputMaybe<Array<AnalysisEmployeeInput>>;
  fundingAmount?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<UpdateAnalysisOptionsInput>;
  remark?: InputMaybe<Scalars['String']['input']>;
  staffingRatio?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAnalysisOptionsInput = {
  districtSubsidy?: InputMaybe<Region>;
  factorIncrease?: InputMaybe<UpdateFactorIncreaseInput>;
  rural?: InputMaybe<RuralKita>;
};

export type UpdateAppointmentInput = {
  absence?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  fullDay?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<AppointmentType>;
  text?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<AppointmentType>;
};

export type UpdateBankInput = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  bankInstitution?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['Bic']['input']>;
  iban?: InputMaybe<Scalars['Iban']['input']>;
};

export type UpdateBirthInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['NaiveDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saintsDay?: InputMaybe<Scalars['NaiveDate']['input']>;
};

export type UpdateBookingInput = {
  assistedIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  districtSubsidy?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionForParentalFeeSubsidy?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionForSubsidy?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['NaiveDate']['input']>;
  institutionSectionId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  isPreSchooler?: InputMaybe<Scalars['Boolean']['input']>;
  isSchoolChild?: InputMaybe<Scalars['Boolean']['input']>;
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  migration?: InputMaybe<Scalars['Boolean']['input']>;
  nurseryChild?: InputMaybe<Scalars['Boolean']['input']>;
  nurseryChildException?: InputMaybe<Scalars['Boolean']['input']>;
  preCourse?: InputMaybe<Scalars['Boolean']['input']>;
  preSchooler?: InputMaybe<Enrollment>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  schoolData?: InputMaybe<UpdateSchoolDataInput>;
  timeFactor?: InputMaybe<UpdateTimeFactorDataInput>;
  timeFactorManuallySet?: InputMaybe<Scalars['Boolean']['input']>;
  times?: InputMaybe<UpdateBookingTimesInput>;
  to?: InputMaybe<Scalars['NaiveDate']['input']>;
  typeObject?: InputMaybe<BookingTypeObjectInput>;
};

export type UpdateBookingTimesInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<AmPmInput>;
  mo?: InputMaybe<AmPmInput>;
  th?: InputMaybe<AmPmInput>;
  tu?: InputMaybe<AmPmInput>;
  we?: InputMaybe<AmPmInput>;
};

export type UpdateCategoryInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCharacteristicInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChildInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<UpdateSimpleAddressInput>;
  allergies?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedToGoHomeAlone?: InputMaybe<Scalars['Boolean']['input']>;
  altChildId?: InputMaybe<Scalars['String']['input']>;
  birth?: InputMaybe<UpdateBirthInput>;
  childId?: InputMaybe<Scalars['Int']['input']>;
  collectorNotes?: InputMaybe<Scalars['String']['input']>;
  collectors?: InputMaybe<Array<CreateCollectorInput>>;
  contact?: InputMaybe<UpdateContactInput>;
  contractDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  contractReceived?: InputMaybe<Scalars['NaiveDate']['input']>;
  disability?: InputMaybe<UpdateDisabilityInput>;
  emergencyMeasures?: InputMaybe<Scalars['String']['input']>;
  externalSiblings?: InputMaybe<Array<ExternalSiblingInput>>;
  financialAccountingData?: InputMaybe<UpdateFinancialAccountingDataInput>;
  healthInsurance?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<UpdatePersonInput>;
  pictureId?: InputMaybe<Scalars['String']['input']>;
  previousInstitutions?: InputMaybe<Array<Scalars['String']['input']>>;
  registration?: InputMaybe<UpdateRegistrationInput>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  vaccination?: InputMaybe<UpdateVaccinationInput>;
  visitingNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChildStateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['StrictEntityId']['input'];
};

export type UpdateCommuneInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<UpdateSimpleAddressInput>;
  comments?: InputMaybe<Scalars['String']['input']>;
  communeKey?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<UpdateContactPersonInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  email2?: InputMaybe<Scalars['String']['input']>;
  letterSalutation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  phoneWork?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactPersonInput = {
  address?: InputMaybe<UpdateSimpleAddressInput>;
  contact?: InputMaybe<UpdateContactInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractFeeTypeInput = {
  accountingGroupId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  endDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  feeTypeId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractInput = {
  endOfContract?: InputMaybe<Scalars['NaiveDate']['input']>;
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  startOfContract?: InputMaybe<Scalars['NaiveDate']['input']>;
  state?: InputMaybe<ContractStateInput>;
};

export type UpdateCustodianChildInput = {
  allowedToCare?: InputMaybe<Scalars['Boolean']['input']>;
  alone?: InputMaybe<Scalars['Boolean']['input']>;
  aloneCare?: InputMaybe<Scalars['Boolean']['input']>;
  post?: InputMaybe<Scalars['Boolean']['input']>;
  relation?: InputMaybe<Relation>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  sepaMandateId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type UpdateCustodianInput = {
  address?: InputMaybe<UpdateSimpleAddressInput>;
  bankDetails?: InputMaybe<UpdateBankInput>;
  birth?: InputMaybe<UpdateBirthInput>;
  collectiveInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<UpdateContactInput>;
  employerId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  financialAccountingData?: InputMaybe<UpdateFinancialAccountingDataInput>;
  honoraryPost?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  person?: InputMaybe<UpdatePersonInput>;
  profession?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDebtorAgreementContractFeeTypeInput = {
  contractFeeTypeId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  contributionType?: InputMaybe<ContributionType>;
  contributionValue?: InputMaybe<Scalars['Float']['input']>;
  debtorAgreementId?: InputMaybe<Scalars['StrictEntityId']['input']>;
};

export type UpdateDebtorAgreementInput = {
  debtorId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  endDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  reference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  totalMaxAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateDebtorInput = {
  addressId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  contractId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  custodianChildId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  youthWelfareOfficeId?: InputMaybe<Scalars['StrictEntityId']['input']>;
};

export type UpdateDisabilityInput = {
  certified?: InputMaybe<Scalars['Boolean']['input']>;
  certifiedUntil?: InputMaybe<Scalars['NaiveDate']['input']>;
  intellectual?: InputMaybe<Scalars['Boolean']['input']>;
  mental?: InputMaybe<Scalars['Boolean']['input']>;
  physical?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEmployeeGroupInput = {
  employeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  from?: InputMaybe<Scalars['NaiveDate']['input']>;
  groupId?: InputMaybe<Scalars['ObjectId']['input']>;
  role?: InputMaybe<GroupRole>;
  to?: InputMaybe<Scalars['NaiveDate']['input']>;
};

export type UpdateEmployeeInput = {
  address?: InputMaybe<UpdateSimpleAddressInput>;
  birth?: InputMaybe<UpdateBirthInput>;
  certificateOfGoodConduct?: InputMaybe<Scalars['NaiveDate']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<UpdateContactInput>;
  education?: InputMaybe<Scalars['String']['input']>;
  educationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  kitalinoExport?: InputMaybe<Scalars['Boolean']['input']>;
  movement?: InputMaybe<UpdateMovementInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  person?: InputMaybe<UpdatePersonInput>;
  personnelNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  statisticsEducation?: InputMaybe<Scalars['String']['input']>;
  statisticsPositionType?: InputMaybe<Scalars['String']['input']>;
  vaccination?: InputMaybe<UpdateVaccinationInput>;
};

export type UpdateEmployeeQualificationInput = {
  employeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  from?: InputMaybe<Scalars['NaiveDate']['input']>;
  qualificationId?: InputMaybe<Scalars['ObjectId']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  resubmission?: InputMaybe<Scalars['NaiveDate']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['NaiveDate']['input']>;
};

/**
 * Only one value between "position" and "interruption" is allowed.
 * To uphold this invariant, the `UpdateEmploymentInputValidator` must be used whereever `UpdateEmployemntInput` is used as an input.
 */
export type UpdateEmploymentInput = {
  additionalStaff?: InputMaybe<Scalars['Boolean']['input']>;
  beginMode?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  creditableWorkingHours?: InputMaybe<Scalars['Float']['input']>;
  employeeId?: InputMaybe<Scalars['ObjectId']['input']>;
  endMode?: InputMaybe<Scalars['String']['input']>;
  excludedFromStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  institutionSectionWorkingHours?: InputMaybe<Array<SectionTimeInput>>;
  interruption?: InputMaybe<Interruption>;
  movement?: InputMaybe<UpdateMovementInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Position>;
  statisticsAreaWorkingHours?: InputMaybe<Array<StatisticsAreaWorkingHoursInput>>;
  times?: InputMaybe<UpdateTimesInput>;
  vacationDays?: InputMaybe<Scalars['Int']['input']>;
  workingHours?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFactorIncreaseInput = {
  number?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<FactorType>;
};

export type UpdateFeeDraftFeeTypeInput = {
  defaultAccountingGroupId?: InputMaybe<Scalars['ObjectId']['input']>;
  feeDraftId?: InputMaybe<Scalars['ObjectId']['input']>;
  feeTypeId?: InputMaybe<Scalars['ObjectId']['input']>;
};

export type UpdateFeeDraftInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeeInput = {
  accountedByAccountingRunId?: InputMaybe<Scalars['ObjectId']['input']>;
  addedByAccountingRunId?: InputMaybe<Scalars['ObjectId']['input']>;
  debtors?: InputMaybe<Array<CreateFeeDebtorInput>>;
  status?: InputMaybe<AccountedStatus>;
  text?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<UpdateFeeValueInput>;
};

export type UpdateFeeTicketInput = {
  accountedStatus?: InputMaybe<AccountedStatus>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  yearMonth?: InputMaybe<Scalars['YearMonth']['input']>;
};

export type UpdateFeeTypeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<FeeCategory>;
  contributionRates?: InputMaybe<Array<ContributionRateInput>>;
  /**
   * "Beitragsschema"
   * Refers to an accounting group
   */
  defaultAccountingGroupId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  fibuData?: InputMaybe<Scalars['String']['input']>;
  generalCategory?: InputMaybe<GeneralFeeCategory>;
  /** Unique id */
  idString?: InputMaybe<Scalars['String']['input']>;
  /** Unique name */
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Description with placeholders */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeeValueInput = {
  bookingTimeCategory?: InputMaybe<BookingTimeCategory>;
  factor?: InputMaybe<Scalars['Float']['input']>;
  singleBrutto?: InputMaybe<Scalars['Float']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFinancialAccountingDataInput = {
  fadNumber?: InputMaybe<Scalars['String']['input']>;
  objectNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFoodTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupContractInput = {
  groupId?: InputMaybe<Scalars['StrictEntityId']['input']>;
  movement?: InputMaybe<UpdateMovementInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupInput = {
  actionGroup?: InputMaybe<Scalars['Boolean']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  careTimes?: InputMaybe<TimesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceColor?: InputMaybe<Scalars['String']['input']>;
  synchronized?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInstitutionSectionInput = {
  contactPerson?: InputMaybe<UpdateContactPersonInput>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  hexColor?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortname?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InstitutionType>;
};

export type UpdateMainDebtorInput = {
  contractId?: InputMaybe<Scalars['ObjectId']['input']>;
  custodianChildId?: InputMaybe<Scalars['ObjectId']['input']>;
  endDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  startDate?: InputMaybe<Scalars['NaiveDate']['input']>;
};

export type UpdateMovementInput = {
  entry?: InputMaybe<Scalars['NaiveDate']['input']>;
  exit?: InputMaybe<Scalars['NaiveDate']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOpeningHoursInput = {
  integrativePlace?: InputMaybe<IntegrativePlace>;
  placesNecessity?: InputMaybe<PlaceNecessity>;
  times?: InputMaybe<TimesInput>;
};

export type UpdatePersonInput = {
  citizenships?: InputMaybe<Array<Scalars['String']['input']>>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  familyLanguageIsNotGerman?: InputMaybe<Scalars['Boolean']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  middlename?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlaceInput = {
  adolescent?: InputMaybe<Scalars['Int']['input']>;
  approved?: InputMaybe<Scalars['Int']['input']>;
  general?: InputMaybe<Scalars['Int']['input']>;
  integrative?: InputMaybe<Scalars['Int']['input']>;
  meal?: InputMaybe<Scalars['Int']['input']>;
  schoolChildren?: InputMaybe<Scalars['Int']['input']>;
  toddler?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProjectCustomerInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<UpdateSimpleAddressInput>;
  contactPersons?: InputMaybe<Array<UpdateContactPersonInput>>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectInstitutionInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<UpdateSimpleAddressInput>;
  banks?: InputMaybe<Array<UpdateBankInput>>;
  communeId?: InputMaybe<Scalars['ObjectId']['input']>;
  contactPersons?: InputMaybe<Array<UpdateContactPersonInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  institutionNumber?: InputMaybe<Scalars['String']['input']>;
  internalInstitutionNumber?: InputMaybe<Scalars['String']['input']>;
  kibigKey?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openingHours?: InputMaybe<UpdateOpeningHoursInput>;
  operatingPermitYear?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<UpdatePlaceInput>;
  sepaConfiguration?: InputMaybe<UpdateSepaConfigurationInput>;
  statistics?: InputMaybe<UpdateStatisticsInput>;
  terminationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  type?: InputMaybe<InstitutionType>;
  yearOfConstruction?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectOrganizationInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<UpdateSimpleAddressInput>;
  contactPersons?: InputMaybe<Array<UpdateContactPersonInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  isUnit?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfMembers?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectOrganizationUnitInput = {
  members?: InputMaybe<Array<InstitutionFilter>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQualificationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRegistrationInput = {
  date?: InputMaybe<Scalars['NaiveDate']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoleInput = {
  accessLevel?: InputMaybe<AccessLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<PermissionInput>>;
};

export type UpdateSchoolDataInput = {
  className?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['StrictEntityId']['input']>;
};

export type UpdateSchoolInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<UpdateSimpleAddressInput>;
  contactPerson?: InputMaybe<UpdateContactPersonInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSepaConfigurationInput = {
  paymentInstitution?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  sepaCreditorIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceTypeInput = {
  bgcolor?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  times?: InputMaybe<UpdateTimeRangeInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSimpleAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStatisticsInput = {
  close?: InputMaybe<Scalars['NaiveTime']['input']>;
  closeMidday?: InputMaybe<Scalars['Boolean']['input']>;
  companyEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  legalForm?: InputMaybe<Scalars['String']['input']>;
  notFixedStructure?: InputMaybe<Scalars['Boolean']['input']>;
  open?: InputMaybe<Scalars['NaiveTime']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
  parentInitiatives?: InputMaybe<Scalars['Boolean']['input']>;
  regionalNumber?: InputMaybe<Scalars['Int']['input']>;
  statisticalNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTimeFactorDataInput = {
  category?: InputMaybe<BookingTimeCategory>;
  daysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  hoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTimeRangeInput = {
  end?: InputMaybe<Scalars['NaiveTime']['input']>;
  start?: InputMaybe<Scalars['NaiveTime']['input']>;
};

export type UpdateTimesInput = {
  fr?: InputMaybe<Array<TimeRangeInput>>;
  mo?: InputMaybe<Array<TimeRangeInput>>;
  sa?: InputMaybe<Array<TimeRangeInput>>;
  su?: InputMaybe<Array<TimeRangeInput>>;
  th?: InputMaybe<Array<TimeRangeInput>>;
  tu?: InputMaybe<Array<TimeRangeInput>>;
  we?: InputMaybe<Array<TimeRangeInput>>;
};

export type UpdateUserAccessInput = {
  access: AccessInput;
  roleId: Scalars['RoleId']['input'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  kibigKey?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['RoleId']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVaccinationInput = {
  contraindicationEndDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  earlyDiagnosticsCertified?: InputMaybe<Scalars['Boolean']['input']>;
  firstConfirmationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  proofDoubts?: InputMaybe<Scalars['String']['input']>;
  reportDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  secondConfirmationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  status?: InputMaybe<VaccinationStatus>;
  tetanusVaccinationDate?: InputMaybe<Scalars['NaiveDate']['input']>;
  vaccinationCertified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateYouthWelfareOfficeInput = {
  additionalAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  address?: InputMaybe<UpdateSimpleAddressInput>;
  collectiveInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  contactPerson?: InputMaybe<UpdateContactPersonInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  financialAccountingData?: InputMaybe<UpdateFinancialAccountingDataInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  customer?: Maybe<Customer>;
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['LongEntityId']['output'];
  institution?: Maybe<Institution>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  kibigKey?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  n: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationUnit?: Maybe<OrganizationUnit>;
  phone?: Maybe<Scalars['String']['output']>;
  roleId: Scalars['RoleId']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
  username: Scalars['String']['output'];
};

export type UserList = {
  __typename?: 'UserList';
  items: Array<User>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type Vacation1 = {
  __typename?: 'Vacation1';
  bookingDays: BookingDays;
  /** This will reflect the variant of the `BookingDays` object */
  bookingDaysEnum: BookingDaysEnum;
};

export type Vacation1Input = {
  bookingDays: BookingDaysInput;
};

export type Vacation2 = {
  __typename?: 'Vacation2';
  bookingDays: BookingDays;
  /** This will reflect the variant of the `BookingDays` object */
  bookingDaysEnum: BookingDaysEnum;
};

export type Vacation2Input = {
  bookingDays: BookingDaysInput;
};

export type Vacation3 = {
  __typename?: 'Vacation3';
  bookingDays: BookingDays;
  /** This will reflect the variant of the `BookingDays` object */
  bookingDaysEnum: BookingDaysEnum;
};

export type Vacation3Input = {
  bookingDays: BookingDaysInput;
};

export type Vaccination = {
  __typename?: 'Vaccination';
  /**
   * This is date since contraindication and was called `ismmoeglab` in the
   * legacy application.
   */
  contraindicationEndDate?: Maybe<Scalars['NaiveDate']['output']>;
  /** This confirms that all early diagnostics where performed. */
  earlyDiagnosticsCertified?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This is the date of the first vaccination and was called `ism1dat` in the
   * legacy application.
   */
  firstConfirmationDate?: Maybe<Scalars['NaiveDate']['output']>;
  /**
   * This is the date of the last change of the vaccination status and was
   * called `ismstatdat` in the legacy application.
   */
  lastStatusUpdate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * This is the description of complications and was called `ismzweifel` in
   * the legacy application.
   */
  proofDoubts?: Maybe<Scalars['String']['output']>;
  /**
   * This is the date at which the vaccination was reported to the health
   * department and was called `ismmelddat` in the legacy application.
   */
  reportDate?: Maybe<Scalars['NaiveDate']['output']>;
  /**
   * This is the date of the first vaccination and was called `ism2dat` in the
   * legacy application.
   */
  secondConfirmationDate?: Maybe<Scalars['NaiveDate']['output']>;
  /**
   * This is the vaccination status and was called `ismstatus` in the legacy
   * application.
   */
  status?: Maybe<VaccinationStatus>;
  /** This is the date of the tetanus vaccination. */
  tetanusVaccinationDate?: Maybe<Scalars['NaiveDate']['output']>;
  /**
   * This confirms the vaccination requirement is fulfilled or vaccination
   * consultation was taken.
   */
  vaccinationCertified?: Maybe<Scalars['Boolean']['output']>;
};

export enum VaccinationStatus {
  /** Vaccination fulfilled, person is below 12 months old */
  J0 = 'J0',
  /** Vaccination fulfilled, person below 12 months had first shot */
  J0_1 = 'J0_1',
  /** Vaccination fulfilled, person below 12 months had second shot */
  J0_2 = 'J0_2',
  /** Vaccination fulfilled, person below 12 has all required shots */
  J0_12 = 'J0_12',
  /** Vaccination fulfilled, person is below 24 months old */
  J1 = 'J1',
  /** Vaccination fulfilled, person below 24 months had second shot */
  J1_2 = 'J1_2',
  /** Vaccination fulfilled, person is has all required shots */
  J2 = 'J2',
  /** Vaccination fulfilled, person has attested immunity */
  J3 = 'J3',
  /** Vaccination fulfilled, person has attested contraindication */
  J4 = 'J4',
  /** Vaccination fulfilled, person with contraintication has all required shots */
  J4_1 = 'J4_1',
  /** Vaccination fulfilled, person has external proof */
  J5 = 'J5',
  /**
   * Vaccination incomplete, since no proof was provided until 2022-07-31;
   * Person is in the institution since before 2020-03-01
   */
  N1 = 'N1',
  /** Vaccination incomplete, because of doubts about the provided proof */
  N2 = 'N2',
  /** Vaccination incomplete */
  N3 = 'N3',
  /** Vaccination incomplete, since no proof was provided at follow-up inspection */
  N4 = 'N4',
  N5 = 'N5',
  /** Vaccination incomplete */
  N6 = 'N6',
  /**
   * Vaccination incomplete, since no proof was provided;
   * Person was accepted anyway
   */
  N7 = 'N7',
  /**
   * Vaccination incomplete, since no proof was provided;
   * Person was accepted due to authority exception (e.g. missing vaccine)
   */
  N8 = 'N8'
}

export type Year = {
  __typename?: 'Year';
  end: Scalars['NaiveDate']['output'];
  mode: YearMode;
  start: Scalars['NaiveDate']['output'];
};

export type YearInput = {
  end: Scalars['NaiveDate']['input'];
  mode: YearMode;
  start: Scalars['NaiveDate']['input'];
};

export enum YearMode {
  /** Kindergarden year */
  C = 'C',
  /** Calendar year */
  K = 'K'
}

/** An owned version of an RcObject, used to send to the frontend to add data such as `id`, `organization`, `institution` and `linked_to`. */
export type YouthWelfareOffice = {
  __typename?: 'YouthWelfareOffice';
  additionalAddress?: Maybe<Array<Scalars['String']['output']>>;
  address?: Maybe<SimpleAddress>;
  collectiveInvoice: Scalars['Boolean']['output'];
  contactPerson?: Maybe<ContactPerson>;
  debtorNumber: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  financialAccountingData: FinancialAccountingData;
  id: Scalars['LongEntityId']['output'];
  institution?: Maybe<ProjectInstitution>;
  linkedTo: Array<Institution>;
  n: Scalars['Int']['output'];
  organization?: Maybe<ProjectOrganization>;
  phone?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type YouthWelfareOfficeList = {
  __typename?: 'YouthWelfareOfficeList';
  items: Array<YouthWelfareOffice>;
  limit?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};
